


<div class="col-md-12" *ngIf="travellerDetail" >
    <div class="outside-container mt-4">
        <div class="box-container ">
          <!-- <div *ngIf="userType==='STAFF'" class="col-md-12 row d-flex justify-content-center " style="padding-left: 20px; ">
            First, emulate the user,  <mat-icon style="width: 50px;" class="pointer">forward</mat-icon> and then proceed to the booking page    
    
          </div> -->
            <div  class="col-md-12 row d-flex justify-content-center " style="padding-left: 20px; ">
              <div *ngIf="swingGenerate" class=" col-md-12 gif-container">  <img   src="../../../assets/images/Airplaneloader.gif" alt=""    >  </div> 
              
                <div *ngIf="!swingGenerate" class="col-md-12 row">
                <div *ngIf="!paymentDetail" class="col-md-9" style=" height:85vh;overflow-y: auto;">
              <mat-stepper orientation="vertical" [linear]="true" #stepper>
                <mat-step [stepControl]="firstFormGroup">
                  <form [formGroup]="firstFormGroup">
                    <ng-template matStepLabel>Review your itinerary
                        
                    </ng-template>
                       <!--############## 1stFlights     #################### -->
                           <!--############## 1stFlights     #################### -->
                           <!--############## 1stFlights     #################### -->
                           <!--############## 1stFlights     #################### -->
                           <span *ngFor="let flightIte of flighItiList">
                    <div ><span>{{cityFilter(flightIte?.flightDetailsList[0]?.fromAirport)}}</span><span style="padding-left: 5px;"><mat-icon style="font-size: 15px;padding-top: 10px; ">arrow_forward</mat-icon></span><span>{{cityFilter(flightIte?.flightDetailsList[flightIte?.flightDetailsList.length-1]?.toAirport)}}</span> <span *ngIf="flightIte?.schDepartureTime" style="color: rgb(150, 144, 144);"> {{dateFormate(flightIte?.schDepartureTime)}}</span></div>
    
                    <div class="flights pt-3" *ngFor="let item of flightIte?.flightDetailsList">
                        <div class="flight-details">
                          <img class="carrier-logo" [src]="flightlogoFilter(item?.carrierName)"  alt="">
    
                           
                          <div class="carrier-info">
                            <div>{{ fligthNameFilter(item?.carrierName )}}</div>
                            <div class="flight-number">{{ item?.carrierName }} - {{ item?.flightNumber }}</div>
                          </div>
                        </div>
                        <svg class="line" width="1200" height="100" >
                            
                            <circle fill="#999" cx="4.5" cy="4.5" r="4.5"></circle>
                            <text x="59.5" y="15" text-anchor="start" font-size="14"  fill="#000">{{ timeFormate(item?.schDepartureTime) }} {{item?.fromAirport}} {{airPortFilter(item?.fromAirport)}} {{item?.fromTerminal?("Terminal "+item?.fromTerminal):''}}</text>
                            <text x="59.5" y="50.5" text-anchor="start" font-size="16" fill="#000">⌚ {{ calculateDuration(item?.schArrivalTime,item?.schDepartureTime) }}</text>
    
                            <circle fill="#999" cx="4.5" cy="92.5" r="4.5"></circle>
                            <text x="59.5" y="83.5" text-anchor="start"  font-size="14" fill="#000">{{ timeFormate(item?.schArrivalTime)}} {{item?.toAirport}} {{airPortFilter(item?.toAirport)}} {{item?.toTerminal?("Terminal "+item?.toTerminal):''}}</text>
      
                            <path stroke="#999" stroke-linecap="square" stroke-dasharray="7" d="M4.5 7v84"></path>
                          </svg>
                        
                      </div>
                      </span>
                      <span *ngIf="false" >
                            <!--############## secondFlights     #################### -->
                           <!--############## secondFlights     #################### -->
                           <!--############## secondFlights     #################### -->
                           <!--############## secondFlights     #################### -->
                      <mat-divider *ngIf="returnFlights" class="mt-2 mb-2 "></mat-divider>
                      <div *ngIf="returnFlights" ><span>{{cityFilter(returnFlights?.flightDetailsList[0]?.fromAirport)}}</span><span style="padding-left: 5px;"><mat-icon style="font-size: 15px;padding-top: 10px; ">arrow_forward</mat-icon></span><span>{{cityFilter(returnLastFlight?.toAirport)}}</span> <span *ngIf="returnFlights?.schDepartureTime" style="color: rgb(150, 144, 144);"> {{dateFormate(returnFlights?.schDepartureTime)}}</span></div>
                      <span *ngIf="returnFlights" >
                      <div  class="flights pt-3" *ngFor="let item of returnFlights.flightDetailsList">
                          <div class="flight-details">
                            <img class="carrier-logo" [src]="flightlogoFilter(item?.carrierName)"  alt="">
    
                            <div class="carrier-info">
                              <div>{{ fligthNameFilter(item?.carrierName )}}</div>
                              <div class="flight-number">{{ item?.carrierName }} - {{ item?.flightNumber }}</div>
                            </div>
                          </div>
                          <svg class="line" width="1200" height="100" >
                              
                              <circle fill="#999" cx="4.5" cy="4.5" r="4.5"></circle>
                              <text x="59.5" y="15" text-anchor="start" font-size="14"  fill="#000">{{ timeFormate(item?.schDepartureTime) }} {{item?.fromAirport}} {{airPortFilter(item?.fromAirport)}} {{item?.fromTerminal?("Terminal "+item?.fromTerminal):''}}</text>
                              <text x="59.5" y="50.5" text-anchor="start" font-size="16" fill="#000">⌚ {{calculateDuration(item?.schArrivalTime,item?.schDepartureTime)}}</text>
      
                              <circle fill="#999" cx="4.5" cy="92.5" r="4.5"></circle>
                              <text x="59.5" y="83.5" text-anchor="start"  font-size="14" fill="#000">{{ timeFormate(item?.schArrivalTime)}} {{item?.toAirport}} {{airPortFilter(item?.toAirport)}} {{item?.toTerminal?("Terminal "+item?.toTerminal):''}}</text>
        
                              <path stroke="#999" stroke-linecap="square" stroke-dasharray="7" d="M4.5 7v84"></path>
                            </svg>
                          
                        </div></span>
  
                           <!--############## thirdFlights     #################### -->
                           <!--############## thirdFlights     #################### -->
                           <!--############## thirdFlights     #################### -->
                           <!--############## thirdFlights     #################### -->
  
                        <mat-divider *ngIf="thirdFlights" class="mt-2 mb-2 "></mat-divider>
                        <div *ngIf="thirdFlights" ><span>{{cityFilter(thirdFlights?.flightDetailsList[0]?.fromAirport)}}</span><span style="padding-left: 5px;"><mat-icon style="font-size: 15px;padding-top: 10px; ">arrow_forward</mat-icon></span><span>{{cityFilter(thirdLastFlight?.toAirport)}}</span> <span *ngIf="thirdFlights?.schDepartureTime" style="color: rgb(150, 144, 144);"> {{dateFormate(thirdFlights?.schDepartureTime)}}</span></div>
                        <span *ngIf="thirdFlights" >
                        <div  class="flights pt-3" *ngFor="let item of thirdFlights.flightDetailsList">
                            <div class="flight-details">
                              <img class="carrier-logo" [src]="flightlogoFilter(item?.carrierName)"  alt="">
      
                              <div class="carrier-info">
                                <div>{{ fligthNameFilter(item?.carrierName )}}</div>
                                <div class="flight-number">{{ item?.carrierName }} - {{ item?.flightNumber }}</div>
                              </div>
                            </div>
                            <svg class="line" width="1200" height="100" >
                                
                                <circle fill="#999" cx="4.5" cy="4.5" r="4.5"></circle>
                                <text x="59.5" y="15" text-anchor="start" font-size="14"  fill="#000">{{ timeFormate(item?.schDepartureTime) }} {{item?.fromAirport}} {{airPortFilter(item?.fromAirport)}} {{item?.fromTerminal?("Terminal "+item?.fromTerminal):''}}</text>
                                <text x="59.5" y="50.5" text-anchor="start" font-size="16" fill="#000">⌚{{calculateDuration(item?.schArrivalTime,item?.schDepartureTime)}}</text>
        
                                <circle fill="#999" cx="4.5" cy="92.5" r="4.5"></circle>
                                <text x="59.5" y="83.5" text-anchor="start"  font-size="14" fill="#000">{{ timeFormate(item?.schArrivalTime)}} {{item?.toAirport}} {{airPortFilter(item?.toAirport)}} {{item?.toTerminal?("Terminal "+item?.toTerminal):''}}</text>
          
                                <path stroke="#999" stroke-linecap="square" stroke-dasharray="7" d="M4.5 7v84"></path>
                              </svg>
                            
                          </div></span>
  
                            <!--############## fourthFlights     #################### -->
                           <!--############## fourthFlights     #################### -->
                           <!--############## fourthFlights     #################### -->
                           <!--############## fourthFlights     #################### -->
  
                        <mat-divider *ngIf="fourthFlights" class="mt-2 mb-2 "></mat-divider>
                        <div *ngIf="fourthFlights" ><span>{{cityFilter(fourthFlights?.flightDetailsList[0]?.fromAirport)}}</span><span style="padding-left: 5px;"><mat-icon style="font-size: 15px;padding-top: 10px; ">arrow_forward</mat-icon></span><span>{{cityFilter(fourthLastFlight?.toAirport)}}</span> <span *ngIf="fourthFlights?.schDepartureTime" style="color: rgb(150, 144, 144);"> {{dateFormate(fourthFlights?.schDepartureTime)}}</span></div>
                        <span *ngIf="fourthFlights" >
                        <div  class="flights pt-3" *ngFor="let item of fourthFlights.flightDetailsList">
                            <div class="flight-details">
                              <img class="carrier-logo" [src]="flightlogoFilter(item?.carrierName)"  alt="">
      
                              <div class="carrier-info">
                                <div>{{ fligthNameFilter(item?.carrierName )}}</div>
                                <div class="flight-number">{{ item?.carrierName }} - {{ item?.flightNumber }}</div>
                              </div>
                            </div>
                            <svg class="line" width="1200" height="100" >
                                
                                <circle fill="#999" cx="4.5" cy="4.5" r="4.5"></circle>
                                <text x="59.5" y="15" text-anchor="start" font-size="14"  fill="#000">{{ timeFormate(item?.schDepartureTime) }} {{item?.fromAirport}} {{airPortFilter(item?.fromAirport)}} {{item?.fromTerminal?("Terminal "+item?.fromTerminal):''}}</text>
                                <text x="59.5" y="50.5" text-anchor="start" font-size="16" fill="#000">⌚{{calculateDuration(item?.schArrivalTime,item?.schDepartureTime)}}</text>
        
                                <circle fill="#999" cx="4.5" cy="92.5" r="4.5"></circle>
                                <text x="59.5" y="83.5" text-anchor="start"  font-size="14" fill="#000">{{ timeFormate(item?.schArrivalTime)}} {{item?.toAirport}} {{airPortFilter(item?.toAirport)}} {{item?.toTerminal?("Terminal "+item?.toTerminal):''}}</text>
          
                                <path stroke="#999" stroke-linecap="square" stroke-dasharray="7" d="M4.5 7v84"></path>
                              </svg>
                            
                          </div></span>
    </span>
                    <mat-divider class="mt-4"></mat-divider>
                    <div class="mt-3">
                      <button *ngIf="!swingGenerate" mat-raised-button color="accent" (click)="onItineraryClick()" matStepperNext>Continue</button>
                      <button  *ngIf="swingGenerate"  mat-raised-button color="accent" style="margin-right: 2%; width: 100px;"  ><mat-spinner  diameter="30" ></mat-spinner></button>
    
                    </div>
                  </form>
                  
                </mat-step>
                <mat-step [stepControl]="secondFormGroup" >
                  <ng-template matStepLabel >Add traveller details</ng-template>
                  <form [formGroup]="secondFormGroup" class="col-md-12 " >
                    
                    <div class="zoomI" >
                      <div >
    
                    <div *ngIf="userType==='EMPLOYEE'" formArrayName="passengerDetails" >
                      <small class="color-changing-element" *ngIf="!employeeData?.firstName"> Please Update Your Profile Data!</small>
    
                      <div *ngFor="let con of passengerDetails.controls; let i=index" [formGroupName]="i" class="row">
                    <mat-label class="bold pt-2 pb-2">Adult {{i+1}} </mat-label>
    
                    <mat-label>Traveller name and gender</mat-label>
                    <mat-form-field class="col-md-2" appearance="outline">
                      <mat-label>Title</mat-label>
                      <mat-select matNativeControl name="gender"  formControlName="passengerTitle" >
                        <mat-option [disabled]="!rules.InputPaxInfo" value="MR">Mr</mat-option>
                        <mat-option [disabled]="!rules.InputPaxInfo" value="MRS">Mrs</mat-option>
                        <mat-option [disabled]="!rules.InputPaxInfo" value="MS">Ms</mat-option>
  
                        <!-- <mat-option [disabled]="con.value.passengerTitle===passengerDetails.controls[0].value.passengerTitle" value="MR">Male</mat-option>
                        <mat-option [disabled]="con.value.passengerTitle===passengerDetails.controls[0].value.passengerTitle" value="MRS">Female</mat-option>
     -->
                      </mat-select> 
                    </mat-form-field> 
                    <mat-form-field class="col-md-5" appearance="outline">
                      <mat-label>Traveller name</mat-label>
                      <input matInput type="text" name="name" [readonly]="!rules.InputPaxInfo"  formControlName="firstName" >
                      <!-- <input matInput type="text" name="name" [readonly]="con.value.firstName===passengerDetails.controls[0].value.firstName"  formControlName="firstName" > -->
  
                    </mat-form-field> 
    
                    <mat-form-field class="col-md-5" appearance="outline">
                      <mat-label>Last Name</mat-label>
                      <input matInput type="text" minlength="2" name="lastname" [readonly]="!rules.InputPaxInfo"  formControlName="lastName" >
                      <!-- <input matInput type="text" name="lastname" [readonly]="con.value.lastName===passengerDetails.controls[0].value.lastName"  formControlName="lastName" > -->
  
                    </mat-form-field> 
                   
    
                   
                    <mat-form-field class="col-md-5" appearance="outline">
                      <mat-label>Email</mat-label>
                      <input matInput type="text" name="email" formControlName="email" >
                      <input  type="hidden" [value]="con.value.username" formControlName="username">
      
                    </mat-form-field> 
                    <mat-form-field class="col-md-5" appearance="outline">
                      <mat-label>Mobile Number</mat-label>
                      <input matInput type="text" name="mobile" (keypress)="onlyNumberKey($event)"   formControlName="mobile">
                    </mat-form-field> 
                   
                    <div formGroupName="userPassportDetails" *ngIf="travelType==='AI'" class="row">
                      <div  class="title" style="text-align: center;">Passport Details</div>
      
                       <mat-form-field  class="col-md-3 " appearance="outline">
                        <mat-label>Issuing Country	</mat-label>
                        <mat-select     formControlName="passportCountry" >
                          <mat-option class="mat-primary" *ngFor="let country of staticDataService.countryCache" [value]="country.countryName">{{country.countryName}}</mat-option>
                      </mat-select>
                    </mat-form-field>
                    <mat-form-field class="col-md-3 " appearance="outline">
                      <input matInput  formControlName="passportNumber">
                      <mat-label>Number	</mat-label>
                  </mat-form-field>
                    <mat-form-field class="col-md-3 " appearance="outline">
                      <input matInput   [matDatepicker]="PDOB" formControlName="passportDOB" (dateChange)="onDateChange($event, i,'userPassportDetails.passportDOB')">
                      <mat-label>Birth Date	</mat-label>
                      <mat-hint>DD/MM/YYYY</mat-hint>
                      <mat-datepicker-toggle matIconSuffix [for]="PDOB"></mat-datepicker-toggle>
                      <mat-datepicker #PDOB></mat-datepicker>
                  </mat-form-field>
                  <mat-form-field class="col-md-3 " appearance="outline">
                    <input matInput  [matDatepicker]="PDOI" formControlName="passportDOI" (dateChange)="onDateChange($event, i,'userPassportDetails.passportDOI')">
                    <mat-label>Issue Date	</mat-label>
                    <mat-hint>DD/MM/YYYY</mat-hint>
                    <mat-datepicker-toggle matIconSuffix [for]="PDOI"></mat-datepicker-toggle>
                    <mat-datepicker #PDOI></mat-datepicker>
                </mat-form-field>
                <mat-form-field class="col-md-3 " appearance="outline">
                  <input matInput  [matDatepicker]="PDOE" formControlName="passportDOE" (dateChange)="onDateChange($event, i,'userPassportDetails.passportDOE')">
                  <mat-label>Expiry Date</mat-label>
                  <mat-hint>DD/MM/YYYY</mat-hint>
                  <mat-datepicker-toggle matIconSuffix [for]="PDOE"></mat-datepicker-toggle>
                  <mat-datepicker #PDOE></mat-datepicker>
              </mat-form-field>
             
            <mat-form-field class="col-md-3 " appearance="outline">
              <input matInput   formControlName="passportPOI">
              <mat-label>Issuance Place</mat-label>
              
          </mat-form-field>
      
            </div>
            <div formGroupName="userVisaDetails" *ngIf="travelType==='AI'" class="row">
              <div  class="title" style="text-align: center;">VISA Details</div>
      
               <mat-form-field  class="col-md-3 " appearance="outline">
                <input matInput   formControlName="visaNumber">
                <mat-label>Visa Number	</mat-label>
            </mat-form-field>
            <mat-form-field class="col-md-3 " appearance="outline">
              <mat-label>Issuing Country	</mat-label>
              <mat-select     formControlName="issuingCountry" >
              
                <mat-option class="mat-primary" *ngFor="let country of staticDataService.countryCache" [value]="country.countryName">{{country.countryName}}</mat-option>
              </mat-select>
          </mat-form-field>
          <mat-form-field class="col-md-3 " appearance="outline">
            <mat-label>Type of VISA	</mat-label>
            <mat-select     formControlName="type" >
              <mat-option class="mat-primary" value="">--</mat-option>
              <mat-option class="mat-primary" value="B">Business</mat-option>
              <mat-option class="mat-primary" value="T">Tourist</mat-option>
              <mat-option class="mat-primary" value="W">WorkPermit</mat-option>
              <mat-option class="mat-primary" value="G">G4</mat-option>
              <mat-option class="mat-primary" value="S">Student</mat-option>
              <mat-option class="mat-primary" value="D">Dependent</mat-option>
              <mat-option class="mat-primary" value="R">Resident</mat-option>
              <mat-option class="mat-primary" value="M">Migrant</mat-option>
              <mat-option class="mat-primary" value="E">Employee</mat-option>
              <mat-option class="mat-primary" value="H">Hajj</mat-option>
              <mat-option class="mat-primary" value="U">Umrah</mat-option>
              <mat-option class="mat-primary" value="F">FamilyVisa</mat-option>
              </mat-select >
        </mat-form-field>
        <mat-form-field class="col-md-3 " appearance="outline">
          <input matInput  [matDatepicker]="DOI" formControlName="issueDate" (dateChange)="onDateChange($event, i,'userVisaDetails.issueDate')">
          <mat-label>Date of Issue	</mat-label>
          <mat-hint>DD/MM/YYYY</mat-hint>
          <mat-datepicker-toggle matIconSuffix [for]="DOI"></mat-datepicker-toggle>
          <mat-datepicker #DOI></mat-datepicker>
      </mat-form-field>
      <mat-form-field class="col-md-3 " appearance="outline">
        <input matInput  [matDatepicker]="DOE" formControlName="expiryDate" (dateChange)="onDateChange($event, i,'userVisaDetails.expiryDate')">
        <mat-label>Date of Expiry		</mat-label>
        <mat-hint>DD/MM/YYYY</mat-hint>
        <mat-datepicker-toggle matIconSuffix [for]="DOE"></mat-datepicker-toggle>
        <mat-datepicker #DOE></mat-datepicker>
      </mat-form-field>
      <mat-form-field class="col-md-3 " appearance="outline">
      <mat-label>Linked Passport</mat-label>
      <input matInput   formControlName="name">
      
      </mat-form-field>
      </div>
                  <mat-divider class="mt-2 mb-1"></mat-divider>
                </div> </div>
                <div *ngIf="userType==='CORPORATE'||userType==='AGENT'" formArrayName="passengerDetails" >
                 
                  <div class="col-md-5"></div>
                  <div *ngFor="let con of passengerDetails.controls; let i=index" [formGroupName]="i" class="row">
    
                <mat-label class="bold pt-2 pb-2">Adult {{i+1}} </mat-label>
                <!-- <mat-form-field class="col-md-5" appearance="outline" *ngIf="!rules.InputPaxInfo"> -->
                  <!-- *ngIf="retrivePnr!='true'" -->
                <mat-form-field  *ngIf="userType!='AGENT'" class="col-md-5" appearance="outline" >
              
                  <mat-label>Select Passenger {{i+1}}</mat-label>
                  <mat-chip-grid #chipGrids aria-label="city Selection">
                  </mat-chip-grid>
                  <div class="input-with-icon col-md-12">
                  <input  #travellerInput [formControl]="traveller" 
                    [matChipInputFor]="chipGrids" [matAutocomplete]="autoTo"
                    [matChipInputSeparatorKeyCodes]="separatorKeysCodesTo"
                    (matChipInputTokenEnd)="addTo($event)"
                    />
                    <mat-icon>arrow_drop_down</mat-icon>
                  </div>
    
                  <mat-autocomplete #autoTo="matAutocomplete" (optionSelected)="selectedTo($event)">
                    <mat-option value="" *ngIf="usersList?.length===0">{{'Traveller Not Found'}}</mat-option>
                    <mat-option  *ngFor="let item of filteredTo | async" [value]="item.username"  (click)="onfilterClick(item.username,con)">
                      
                      {{item?.firstName}} {{item?.lastName}}, {{item.username}}
                    </mat-option>
                  </mat-autocomplete>
                </mat-form-field>
                <mat-label>Traveller name and gender</mat-label>
                <mat-form-field class="col-md-2" appearance="outline">
                  <mat-label>Title</mat-label>
                  <mat-select matNativeControl name="gender" formControlName="passengerTitle" >
                    <mat-option [disabled]="!rules.InputPaxInfo" value="MR">Mr</mat-option>
                    <mat-option [disabled]="!rules.InputPaxInfo" value="MRS">Mrs</mat-option>
                    <mat-option [disabled]="!rules.InputPaxInfo" value="MS">Ms</mat-option>

                    <!-- <mat-option [disabled]="retrivePnr==='true'" value="MR">Mr</mat-option>
                    <mat-option [disabled]="retrivePnr==='true'" value="MRS">Mrs</mat-option>
                    <mat-option [disabled]="retrivePnr==='true'" value="MS">Ms</mat-option> -->
  
                  </mat-select> 
                </mat-form-field> 
                <mat-form-field class="col-md-5" appearance="outline">
                  <mat-label>Traveller name</mat-label>
                  <!--               <input matInput type="text" name="name" [readonly]="con.value.firstName===passengerDetails.controls[0].value.firstName" formControlName="firstName" >
     -->
                  <input matInput type="text" name="name" [readonly]="seatPagination?.manualCartType==='R'" formControlName="firstName" >
                  <!-- <input matInput type="text" name="name" [readonly]="retrivePnr==='true'" formControlName="firstName" > -->

                </mat-form-field> 
                <mat-form-field class="col-md-5" appearance="outline">
                  <mat-label>Last Name</mat-label>
                  <input matInput type="text" minlength="2" name="last" [readonly]="seatPagination?.manualCartType==='R'" formControlName="lastName" >
                  <!-- <input matInput type="text" name="last" [readonly]="retrivePnr==='true'"  formControlName="lastName" > -->
                  <!--  -->
                </mat-form-field> 
               
                
                <mat-form-field class="col-md-5" appearance="outline">
                  <mat-label>Email</mat-label>
                  <input matInput type="text" name="email" formControlName="email" >
                  <input  type="hidden" [value]="con.value.username" formControlName="username">
  
                </mat-form-field> 
                <mat-form-field class="col-md-5" appearance="outline">
                  <mat-label>Mobile Number</mat-label>
                  <input matInput type="text" name="mobile" (keypress)="onlyNumberKey($event)"   formControlName="mobile">
                </mat-form-field> 
                <div formGroupName="userPassportDetails" *ngIf="travelType==='AI'" class="row">
                  <div  class="title" style="text-align: center;">Passport Details</div>
  
                   <mat-form-field  class="col-md-3 " appearance="outline">
                    <mat-label>Issuing Country	</mat-label>
                    <mat-select     formControlName="passportCountry" >
                      <mat-option class="mat-primary" *ngFor="let country of staticDataService.countryCache" [value]="country.countryName">{{country.countryName}}</mat-option>
                  </mat-select>
                </mat-form-field>
                <mat-form-field class="col-md-3 " appearance="outline">
                  <input matInput  formControlName="passportNumber">
                  <mat-label>Number	</mat-label>
              </mat-form-field>
                <mat-form-field class="col-md-3 " appearance="outline">
                  <input matInput   [matDatepicker]="PDOB" formControlName="passportDOB" (dateChange)="onDateChange($event, i,'userPassportDetails.passportDOB')">
                  <mat-label>Birth Date	</mat-label>
                  <mat-hint>DD/MM/YYYY</mat-hint>
                  <mat-datepicker-toggle matIconSuffix [for]="PDOB"></mat-datepicker-toggle>
                  <mat-datepicker #PDOB></mat-datepicker>
              </mat-form-field>
              <mat-form-field class="col-md-3 " appearance="outline">
                <input matInput  [matDatepicker]="PDOI" formControlName="passportDOI" (dateChange)="onDateChange($event, i,'userPassportDetails.passportDOI')">
                <mat-label>Issue Date	</mat-label>
                <mat-hint>DD/MM/YYYY</mat-hint>
                <mat-datepicker-toggle matIconSuffix [for]="PDOI"></mat-datepicker-toggle>
                <mat-datepicker #PDOI></mat-datepicker>
            </mat-form-field>
            <mat-form-field class="col-md-3 " appearance="outline">
              <input matInput  [matDatepicker]="PDOE" formControlName="passportDOE" (dateChange)="onDateChange($event, i,'userPassportDetails.passportDOE')">
              <mat-label>Expiry Date</mat-label>
              <mat-hint>DD/MM/YYYY</mat-hint>
              <mat-datepicker-toggle matIconSuffix [for]="PDOE"></mat-datepicker-toggle>
              <mat-datepicker #PDOE></mat-datepicker>
          </mat-form-field>
         
        <mat-form-field class="col-md-3 " appearance="outline">
          <input matInput   formControlName="passportPOI">
          <mat-label>Issuance Place</mat-label>
          
      </mat-form-field>
  
        </div>
        <div formGroupName="userVisaDetails" *ngIf="travelType==='AI'" class="row">
          <div  class="title" style="text-align: center;">VISA Details</div>
  
           <mat-form-field  class="col-md-3 " appearance="outline">
            <input matInput   formControlName="visaNumber">
            <mat-label>Visa Number	</mat-label>
        </mat-form-field>
        <mat-form-field class="col-md-3 " appearance="outline">
          <mat-label>Issuing Country	</mat-label>
          <mat-select     formControlName="issuingCountry" >
          
            <mat-option class="mat-primary" *ngFor="let country of staticDataService.countryCache" [value]="country.countryName">{{country.countryName}}</mat-option>
          </mat-select>
      </mat-form-field>
      <mat-form-field class="col-md-3 " appearance="outline">
        <mat-label>Type of VISA	</mat-label>
        <mat-select     formControlName="type" >
          <mat-option class="mat-primary" value="">--</mat-option>
          <mat-option class="mat-primary" value="B">Business</mat-option>
          <mat-option class="mat-primary" value="T">Tourist</mat-option>
          <mat-option class="mat-primary" value="W">WorkPermit</mat-option>
          <mat-option class="mat-primary" value="G">G4</mat-option>
          <mat-option class="mat-primary" value="S">Student</mat-option>
          <mat-option class="mat-primary" value="D">Dependent</mat-option>
          <mat-option class="mat-primary" value="R">Resident</mat-option>
          <mat-option class="mat-primary" value="M">Migrant</mat-option>
          <mat-option class="mat-primary" value="E">Employee</mat-option>
          <mat-option class="mat-primary" value="H">Hajj</mat-option>
          <mat-option class="mat-primary" value="U">Umrah</mat-option>
          <mat-option class="mat-primary" value="F">FamilyVisa</mat-option>
          </mat-select >
    </mat-form-field>
    <mat-form-field class="col-md-3 " appearance="outline">
      <input matInput  [matDatepicker]="DOI" formControlName="issueDate" (dateChange)="onDateChange($event, i,'userVisaDetails.issueDate')">
      <mat-label>Date of Issue	</mat-label>
      <mat-hint>DD/MM/YYYY</mat-hint>
      <mat-datepicker-toggle matIconSuffix [for]="DOI"></mat-datepicker-toggle>
      <mat-datepicker #DOI></mat-datepicker>
  </mat-form-field>
  <mat-form-field class="col-md-3 " appearance="outline">
    <input matInput  [matDatepicker]="DOE" formControlName="expiryDate" (dateChange)="onDateChange($event, i,'userVisaDetails.expiryDate')">
    <mat-label>Date of Expiry		</mat-label>
    <mat-hint>DD/MM/YYYY</mat-hint>
    <mat-datepicker-toggle matIconSuffix [for]="DOE"></mat-datepicker-toggle>
    <mat-datepicker #DOE></mat-datepicker>
  </mat-form-field>
  <mat-form-field class="col-md-3 " appearance="outline">
  <mat-label>Linked Passport</mat-label>
  <input matInput   formControlName="name">
  
  </mat-form-field>
  </div>
              <mat-divider class="mt-2 mb-1"></mat-divider>
            </div> </div>
                  <div formArrayName="passengerChild" >
                    <div *ngFor="let con of passengerChild.controls; let i=index" [formGroupName]="i" class="row">
                  <mat-label class="bold pt-2 pb-2">Child {{i+1}} <span style="color: grey;">(2-12 yrs)</span> </mat-label>
    
                  <mat-label>Traveller name and gender</mat-label>
                  <mat-form-field class="col-md-2" appearance="outline">
                    <mat-label>Title</mat-label>
                    <mat-select matNativeControl name="gender" formControlName="passengerTitle">
                      <mat-option value="MSTR">MSTR</mat-option>
                      <mat-option value="MISS">MISS</mat-option>

                    </mat-select> 
                  </mat-form-field> 
                    <mat-form-field class="col-md-5" appearance="outline">
                      <mat-label>Traveller name</mat-label>
                      <input matInput type="text" name="name" [readonly]="seatPagination?.manualCartType==='R'" formControlName="firstName" >
    
                    </mat-form-field> 
                    <mat-form-field class="col-md-5" appearance="outline">
                      <mat-label>Last Name</mat-label>
                      <input matInput type="text" minlength="2" name="lastname" [readonly]="seatPagination?.manualCartType==='R'"  formControlName="lastName">
    
                    </mat-form-field> 
                   
                   
                    <div formGroupName="userPassportDetails" *ngIf="travelType==='AI'" class="row">
                      <div  class="title" style="text-align: center;">Passport Details</div>
      
                       <mat-form-field  class="col-md-3 " appearance="outline">
                        <mat-label>Issuing Country	</mat-label>
                        <mat-select     formControlName="passportCountry" >
              
                          <mat-option class="mat-primary" *ngFor="let country of staticDataService.countryCache" [value]="country.countryName">{{country.countryName}}</mat-option>
                      </mat-select>
                    </mat-form-field>
                    <mat-form-field class="col-md-3 " appearance="outline">
                      <input matInput  formControlName="passportNumber">
                      <mat-label>Number	</mat-label>
                  </mat-form-field>
                    <mat-form-field class="col-md-3 " appearance="outline">
                      <input matInput  [matDatepicker]="CPDOB" formControlName="passportDOB" (dateChange)="onDateCChange($event, i,'userPassportDetails.passportDOB')">
                      <mat-label>Birth Date	</mat-label>
                      <mat-hint>DD/MM/YYYY</mat-hint>
                      <mat-datepicker-toggle matIconSuffix [for]="CPDOB"></mat-datepicker-toggle>
                      <mat-datepicker #CPDOB></mat-datepicker>
                  </mat-form-field>
                  <mat-form-field class="col-md-3 " appearance="outline">
                    <input matInput  [matDatepicker]="CPDOI" formControlName="passportDOI" (dateChange)="onDateCChange($event, i,'userPassportDetails.passportDOI')">
                    <mat-label>Issue Date	</mat-label>
                    <mat-hint>DD/MM/YYYY</mat-hint>
                    <mat-datepicker-toggle matIconSuffix [for]="CPDOI"></mat-datepicker-toggle>
                    <mat-datepicker #CPDOI></mat-datepicker>
                </mat-form-field>
                <mat-form-field class="col-md-3 " appearance="outline">
                  <input matInput  [matDatepicker]="CPDOE" formControlName="passportDOE" (dateChange)="onDateCChange($event, i,'userPassportDetails.passportDOE')">
                  <mat-label>Expiry Date</mat-label>
                  <mat-hint>DD/MM/YYYY</mat-hint>
                  <mat-datepicker-toggle matIconSuffix [for]="CPDOE"></mat-datepicker-toggle>
                  <mat-datepicker #CPDOE></mat-datepicker>
              </mat-form-field>
             
            <mat-form-field class="col-md-3 " appearance="outline">
              <input matInput   formControlName="passportPOI">
              <mat-label>Issuance Place</mat-label>
              
          </mat-form-field>
      
            </div>
            <div formGroupName="userVisaDetails" *ngIf="travelType==='AI'" class="row">
              <div  class="title" style="text-align: center;">VISA Details</div>
      
               <mat-form-field  class="col-md-3 " appearance="outline">
                <input matInput   formControlName="visaNumber">
                <mat-label>Visa Number	</mat-label>
            </mat-form-field>
            <mat-form-field class="col-md-3 " appearance="outline">
              <mat-label>Issuing Country	</mat-label>
              <mat-select     formControlName="issuingCountry" >
              
                <mat-option class="mat-primary" *ngFor="let country of staticDataService.countryCache" [value]="country.countryName">{{country.countryName}}</mat-option>
              </mat-select>
          </mat-form-field>
          <mat-form-field class="col-md-3 " appearance="outline">
            <mat-label>Type of VISA	</mat-label>
            <mat-select     formControlName="type" >
              <mat-option class="mat-primary" value="">--</mat-option>
              <mat-option class="mat-primary" value="B">Business</mat-option>
              <mat-option class="mat-primary" value="T">Tourist</mat-option>
              <mat-option class="mat-primary" value="W">WorkPermit</mat-option>
              <mat-option class="mat-primary" value="G">G4</mat-option>
              <mat-option class="mat-primary" value="S">Student</mat-option>
              <mat-option class="mat-primary" value="D">Dependent</mat-option>
              <mat-option class="mat-primary" value="R">Resident</mat-option>
              <mat-option class="mat-primary" value="M">Migrant</mat-option>
              <mat-option class="mat-primary" value="E">Employee</mat-option>
              <mat-option class="mat-primary" value="H">Hajj</mat-option>
              <mat-option class="mat-primary" value="U">Umrah</mat-option>
              <mat-option class="mat-primary" value="F">FamilyVisa</mat-option>
              </mat-select >
        </mat-form-field>
        <mat-form-field class="col-md-3 " appearance="outline">
          <input matInput  [matDatepicker]="CDOI" formControlName="issueDate" (dateChange)="onDateCChange($event, i,'userVisaDetails.issueDate')">
          <mat-label>Date of Issue	</mat-label>
          <mat-hint>DD/MM/YYYY</mat-hint>
          <mat-datepicker-toggle matIconSuffix [for]="CDOI"></mat-datepicker-toggle>
          <mat-datepicker #CDOI></mat-datepicker>
      </mat-form-field>
      <mat-form-field class="col-md-3 " appearance="outline">
        <input matInput  [matDatepicker]="CDOE" formControlName="expiryDate" (dateChange)="onDateCChange($event, i,'userVisaDetails.expiryDate')">
        <mat-label>Date of Expiry		</mat-label>
        <mat-hint>DD/MM/YYYY</mat-hint>
        <mat-datepicker-toggle matIconSuffix [for]="CDOE"></mat-datepicker-toggle>
        <mat-datepicker #CDOE></mat-datepicker>
      </mat-form-field>
      <mat-form-field class="col-md-3 " appearance="outline">
      <mat-label>Linked Passport</mat-label>
      <input matInput   formControlName="name">
      
      </mat-form-field>
      </div>
                  <mat-divider class="mt-2 mb-1"></mat-divider>
              </div></div>
              <div formArrayName="passengerInfent" >
                <div *ngFor="let con of passengerInfent.controls; let i=index" [formGroupName]="i" class="row">
               <mat-label class="bold pt-2 pb-2">Infant {{i+1}} <span style="color: grey;">(below 2 yrs)</span> </mat-label>
    
               <mat-label>Traveller name and gender</mat-label>
               <mat-form-field class="col-md-2" appearance="outline">
                <mat-label>Title</mat-label>
                <mat-select matNativeControl name="gender" formControlName="passengerTitle">
                  <mat-option value="MSTR">MSTR</mat-option>
                <mat-option value="MISS">MISS</mat-option>

                </mat-select> 
              </mat-form-field> 
               <mat-form-field class="col-md-5" appearance="outline">
                 <mat-label>Traveller name</mat-label>
                 <input matInput type="text" name="name" [readonly]="seatPagination?.manualCartType==='R'" formControlName="firstName" >
    
               </mat-form-field> 
               <mat-form-field class="col-md-5" appearance="outline">
                 <mat-label>Last Name</mat-label>
                 <input matInput type="text" minlength="2" name="lastname" [readonly]="seatPagination?.manualCartType==='R'"  formControlName="lastName">
    
               </mat-form-field> 
               <div formGroupName="userPassportDetails" *ngIf="travelType==='AI'" class="row">
                <div  class="title" style="text-align: center;">Passport Details</div>
    
                 <mat-form-field  class="col-md-3 " appearance="outline">
                  <mat-label>Issuing Country	</mat-label>
                  <mat-select     formControlName="passportCountry" >
        
                    <mat-option class="mat-primary" *ngFor="let country of staticDataService.countryCache" [value]="country.countryName">{{country.countryName}}</mat-option>
                </mat-select>
              </mat-form-field>
              <mat-form-field class="col-md-3 " appearance="outline">
                <input matInput  formControlName="passportNumber">
                <mat-label>Number	</mat-label>
            </mat-form-field>
              <mat-form-field class="col-md-3 " appearance="outline">
                <input matInput  [matDatepicker]="IPDOB" formControlName="passportDOB" (dateChange)="onDateIChange($event, i,'userPassportDetails.passportDOB')">
                <mat-label>Birth Date	</mat-label>
                <mat-hint>DD/MM/YYYY</mat-hint>
                <mat-datepicker-toggle matIconSuffix [for]="IPDOB"></mat-datepicker-toggle>
                <mat-datepicker #IPDOB></mat-datepicker>
            </mat-form-field>
            <mat-form-field class="col-md-3 " appearance="outline">
              <input matInput  [matDatepicker]="IPDOI" formControlName="passportDOI" (dateChange)="onDateIChange($event, i,'userPassportDetails.passportDOI')">
              <mat-label>Issue Date	</mat-label>
              <mat-hint>DD/MM/YYYY</mat-hint>
              <mat-datepicker-toggle matIconSuffix [for]="IPDOI"></mat-datepicker-toggle>
              <mat-datepicker #IPDOI></mat-datepicker>
          </mat-form-field>
          <mat-form-field class="col-md-3 " appearance="outline">
            <input matInput  [matDatepicker]="IPDOE" formControlName="passportDOE" (dateChange)="onDateIChange($event, i,'userPassportDetails.passportDOE')">
            <mat-label>Expiry Date</mat-label>
            <mat-hint>DD/MM/YYYY</mat-hint>
            <mat-datepicker-toggle matIconSuffix [for]="IPDOE"></mat-datepicker-toggle>
            <mat-datepicker #IPDOE></mat-datepicker>
        </mat-form-field>
       
      <mat-form-field class="col-md-3 " appearance="outline">
        <input matInput   formControlName="passportPOI">
        <mat-label>Issuance Place</mat-label>
        
    </mat-form-field>
    
      </div>
      <div formGroupName="userVisaDetails" *ngIf="travelType==='AI'" class="row">
        <div  class="title" style="text-align: center;">VISA Details</div>
    
         <mat-form-field  class="col-md-3 " appearance="outline">
          <input matInput   formControlName="visaNumber">
          <mat-label>Visa Number	</mat-label>
      </mat-form-field>
      <mat-form-field class="col-md-3 " appearance="outline">
        <mat-label>Issuing Country	</mat-label>
        <mat-select     formControlName="issuingCountry" >
        
          <mat-option class="mat-primary" *ngFor="let country of staticDataService.countryCache" [value]="country.countryName">{{country.countryName}}</mat-option>
        </mat-select>
    </mat-form-field>
    <mat-form-field class="col-md-3 " appearance="outline">
      <mat-label>Type of VISA	</mat-label>
      <mat-select     formControlName="type" >
        <mat-option class="mat-primary" value="">--</mat-option>
        <mat-option class="mat-primary" value="B">Business</mat-option>
        <mat-option class="mat-primary" value="T">Tourist</mat-option>
        <mat-option class="mat-primary" value="W">WorkPermit</mat-option>
        <mat-option class="mat-primary" value="G">G4</mat-option>
        <mat-option class="mat-primary" value="S">Student</mat-option>
        <mat-option class="mat-primary" value="D">Dependent</mat-option>
        <mat-option class="mat-primary" value="R">Resident</mat-option>
        <mat-option class="mat-primary" value="M">Migrant</mat-option>
        <mat-option class="mat-primary" value="E">Employee</mat-option>
        <mat-option class="mat-primary" value="H">Hajj</mat-option>
        <mat-option class="mat-primary" value="U">Umrah</mat-option>
        <mat-option class="mat-primary" value="F">FamilyVisa</mat-option>
        </mat-select >
    </mat-form-field>
    <mat-form-field class="col-md-3 " appearance="outline">
    <input matInput  [matDatepicker]="IDOI" formControlName="issueDate" (dateChange)="onDateIChange($event, i,'userVisaDetails.issueDate')">
    <mat-label>Date of Issue	</mat-label>
    <mat-hint>DD/MM/YYYY</mat-hint>
    <mat-datepicker-toggle matIconSuffix [for]="IDOI"></mat-datepicker-toggle>
    <mat-datepicker #IDOI></mat-datepicker>
    </mat-form-field>
    <mat-form-field class="col-md-3 " appearance="outline">
    <input matInput  [matDatepicker]="IDOE" formControlName="expiryDate" (dateChange)="onDateIChange($event, i,'userVisaDetails.expiryDate')">
    <mat-label>Date of Expiry		</mat-label>
    <mat-hint>DD/MM/YYYY</mat-hint>
    <mat-datepicker-toggle matIconSuffix [for]="IDOE"></mat-datepicker-toggle>
    <mat-datepicker #IDOE></mat-datepicker>
    </mat-form-field>
    <mat-form-field class="col-md-3 " appearance="outline">
    <mat-label>Linked Passport</mat-label>
    <input matInput   formControlName="name">
    
    </mat-form-field>
    </div>
              
              
              
                <mat-divider class="mt-2 mb-1"></mat-divider>
            </div>
    
          </div>
    
     
          <div *ngIf="userType!='AGENT'" class="title" style="text-align: center;"> Reporting Details</div>
    
          <mat-form-field *ngIf="userType!='AGENT'" class="col-md-6" appearance="outline">
            <mat-label>Billing Entity</mat-label>
            <mat-select   matNativeControl name="entity"  required  >
              <mat-option *ngFor="let item of DataEntity"   (click)="addBillingEntity(item)"  [value]="item?.entityName" >{{item?.entityName}} {{item?.entityGST?('('+item?.entityGST+')'):''}}</mat-option>
            </mat-select>
    
            <small *ngIf="!billingDetail" style="color: red;">Please Select Billing Entity! </small>
          </mat-form-field> 
    
         
    
          <div class="  col-md-6">
            
          </div>

          <div class="col-md-6 mb-3" *ngIf="userType!='EMPLOYEE'&&userType!='AGENT'" >


            <div  formArrayName="passengerDetails" >
              <div class="d-flex justify-content-start" style="width: 100%;overflow-y: auto;">
           
                <table *ngFor="let con of passengerDetails.controls; let i=index" [formGroupName]="i"  class="styled-tables "    >
                  <ng-container  *ngIf="i===0" >
                   
                  <tbody *ngIf="con.value.lastName" formArrayName="reportingTags">
          
                    <ng-container *ngFor="let tag of getReportingTagsControls(con); let j = index" [formGroupName]="j">
                  <tr   *ngIf="tag.value['fieldType']==='F'">
                    <th *ngIf="i===0"   style="padding: 8px; text-align: start;white-space: nowrap;" [class]="tag.value.required==='C'?('form-group required'):''">
                      <label>{{tag.value.displayName}}</label>
                      </th>
                    <!-- <td> </td> -->
                    <td  style="padding: 8px; text-align: start;min-width:200px" >
                      
                      <input *ngIf="tag.value['fieldType']==='F'" type="file" [accept]="acceptedTypes" class="form-control" (change)="onFileChange($event,j,con)"  formControlName="value" >
                    <span class="file-types-msg">
    Acceptable file types: {{ acceptedTypes }}
  </span>

                    </td>
                  </tr>
                </ng-container>
                
                </tbody >
              </ng-container>
                </table>
               
          </div>
          
          </div></div>
  
  
  <div class="col-md-12" *ngIf="userType!='EMPLOYEE'&&userType!='AGENT'" >
  
  
    <div  formArrayName="passengerDetails" >
      <div class="d-flex justify-content-start" style="width: 100%;overflow-y: auto;">
   
        <table *ngFor="let con of passengerDetails.controls; let i=index" [formGroupName]="i"  class="styled-tables "    >
          <ng-container  >
            <thead *ngIf="con.value.lastName" >
              <tr   >       
                <th  *ngIf="i===0"  style="min-width: 80px;"><button mat-flat-button style="background-color: #1876D1;color: #fff;" (click)="rmTagsCopy()">Copy</button></th>
                <th  ><mat-label  class="bold pt-2 pb-2"></mat-label> <button mat-flat-button style="background-color: #8fc0f1;color: #fff;margin-left: 4px;" disabled>Adult {{i+1}} </button></th>
               
              </tr>
            </thead>
          <tbody *ngIf="con.value.lastName" formArrayName="reportingTags">
  
            <ng-container *ngFor="let tag of getReportingTagsControls(con); let j = index" [formGroupName]="j">
          <tr   *ngIf="tag.value['fieldType']!='F'">
            <th *ngIf="i===0"   style="padding: 8px; text-align: start;white-space: nowrap;" [class]="tag.value.required==='C'?('form-group required'):''">
              <label>{{tag.value.displayName}}</label>
              </th>
            <!-- <td> </td> -->
            <td  style="padding: 8px; text-align: start;min-width:300px" >
              <input *ngIf="tag.value['fieldType']==='T'" type="text" class="form-control" formControlName="value" >
              <mat-select *ngIf="tag.value['fieldType']==='D'" matNativeControl    class="form-control"   formControlName="value">
                <mat-option class="mat-primary "   *ngFor="let tagValue of tagDropDown(tag.value['checkValue'])" [value]="tagValue">{{tagValue}}</mat-option>
  
              </mat-select> 
              <!-- <input *ngIf="tag.value['fieldType']==='F'" type="file" class="form-control" (change)="onFileChange($event,j,con)"  formControlName="value" > -->
            </td>
          </tr>
        </ng-container>
        
        </tbody >
      </ng-container>
        </table>
       
  </div>
  
  </div>
  
  
  
  
  
  
         
  </div>






  <div class="col-md-10" *ngIf="false">
          <div  formArrayName="passengerDetails" >
            <div *ngFor="let con of passengerDetails.controls; let i=index" [formGroupName]="i" class="row">
          <mat-label *ngIf="con.value.firstName" class="bold pt-2 pb-2">Adult {{i+1}} </mat-label>
          <!-- <table class="styled-tables " >
            <thead>
              <tr >
          
              </tr>
            </thead>
            <tbody >
              <tr *ngFor="let tags of con.get('reportingTags').controls; let j = index" [formGroupName]="j">
                <th style="padding: 8px;  text-align: start;" [class]="tags.required==='C'?('form-group required'):''"><label for="" class="">{{tags.displayName}}</label></th>
                <td style="padding: 8px;  text-align: start;" *ngIf="tags.tagValue['show to admin']==='Y'&&!tags.tagFixedValue.includes(':')"><input  type="text" class="form-control"  formControlName="tags.value"></td>
                <td style="padding: 8px;  text-align: start;" *ngIf="tags.tagValue['show to admin']==='Y'&&tags.tagFixedValue.includes(':')"><input  type="text" class="form-control"  [formControlName]="tags.tagFixedValue.split(':')[1]"></td>
  
                </tr>
              </tbody>
              
              </table> -->
              <table *ngIf="con.value.firstName" class="styled-tables " >
                <tbody formArrayName="reportingTags">
  
                <tr  *ngFor="let tag of getReportingTagsControls(con); let j = index" [formGroupName]="j">
                  <th style="padding: 8px; text-align: start;" [class]="tag.value.required==='C'?('form-group required'):''">
                    <label>{{tag.value.displayName}}</label>
                  </th>
                  <td style="padding: 8px; text-align: start;">
                    <!-- <input type="text" class="form-control" formControlName="value" > -->

                    <input *ngIf="tag.value['fieldType']==='T'" type="text" class="form-control" formControlName="value" >
                    <!-- <input  type="text" class="form-control" formControlName="value" > -->
                    <mat-select *ngIf="tag.value['fieldType']==='D'" matNativeControl    class="form-control"   formControlName="value">
                      <mat-option class="mat-primary "   *ngFor="let tagValue of tagDropDown(tag.value['checkValue'])" [value]="tagValue">{{tagValue}}</mat-option>
       
                    </mat-select> 
                    <input *ngIf="tag.value['fieldType']==='F'" type="file" class="form-control" (change)="onFileChange($event,j,con)"  formControlName="value" >
  




                  </td>
                </tr>
                <tbody >
  
              </table>
              <!-- <table class="styled-tables " >
                <tbody >
  
                <tr  *ngFor="let tag of con.value.reportingTags; let j = index" >
                  <th style="padding: 8px; text-align: start;" [class]="tag.required==='C'?('form-group required'):''">
                    <label>{{tag.displayName}}</label>
                  </th>
                  <td style="padding: 8px; text-align: start;">
                    <input type="text" class="form-control" [(ngModel)]="tag.value" [ngModelOptions]="{standalone: true}">
                  </td>
                </tr>
                </tbody>
              </table> -->
        </div>
        
      </div>
      
      
    
  
  </div>
      
  
          </div>
        </div>
                </form>
                
                <mat-divider class="mt-2 mb-1"></mat-divider>
    
                  <div class="mt-2" (click)="RequiredPopup()">
                    <button mat-raised-button color="accent" matStepperNext (click)="PassengerDetails()">Continue</button>
                    <!-- <button mat-button (click)="stepper.reset()">Reset</button> -->
                  </div>
                  
                </mat-step>
               
                <mat-step [stepControl]="thirdFormGroup" >
                    <form [formGroup]="thirdFormGroup" class="row">
                      <ng-template matStepLabel>Add contact details</ng-template>
                      
                      <mat-form-field class="col-md-4" appearance="outline">
                        <mat-label>Mobile Number</mat-label>
                        <input matInput type="tel" name="mobile" (keypress)="onlyNumberKey($event)"  formControlName="mobileCtrl">
                        <small *ngIf="thirdFormGroup.controls['mobileCtrl'].dirty && thirdFormGroup.controls['mobileCtrl'].invalid" class="warn">Please enter Mobile Number!</small>
    
                      </mat-form-field> 
                      <mat-form-field class="col-md-4" appearance="outline">
                        <mat-label>Email</mat-label>
                        <input matInput type="email" name="email" formControlName="emailCtrl">
                        <small *ngIf="thirdFormGroup.controls['emailCtrl'].dirty && thirdFormGroup.controls['emailCtrl'].invalid" class="warn">Please enter Email Address!</small>
    
                      </mat-form-field> 
                      <mat-divider class="mt-2"></mat-divider>
    
                      <div class="mt-2">
                        <button mat-raised-button color="accent" matStepperNext>Continue</button>
                      </div>
                    </form>
                  </mat-step>
                  <mat-step [stepControl]="fourthFormGroup" >
                    <form [formGroup]="fourthFormGroup" class="col-md-12 row" >
                      <ng-template matStepLabel >Choose add-ons</ng-template>
                      <!--<ng-template matStepLabel *ngIf="seats.length===0"> Continue to payment</ng-template>-->
    
    
                      <!-- <div class="tabs-container" >
                        <button  class="" mat-icon-button class="arrow arrow-left" (click)="scrollTabs('left')">
                          <mat-icon>keyboard_arrow_left</mat-icon>
                        </button>
                        <div class="tabs tabButton" #tabsRef>
                          <div class="tab" *ngFor="let tab of item.tag" [class.active]="tab.active">{{ tab.meal_desc }}</div>
                        </div>
                        <button class="" mat-icon-button class="arrow arrow-right" (click)="scrollTabs('right')">
                          <mat-icon>keyboard_arrow_right</mat-icon>
                        </button>
                      </div> -->
                      
    
    
                      <div class="col-md-12 mt-3" >
                        
                        <table class="styled-tables ">
                            <thead>
                              <tr >
                                <!-- Dynamic headers based on tableHeaders array -->
                                <th style="padding: 8px;  text-align: center;">Passenger Preferences
                                </th>
                                <th style="padding: 8px;  text-align: center;">Sector</th>
                                <th style="padding: 8px;  text-align: center;" style="min-width:240px ;">Meal Preference  </th>
                                      <th style="padding: 8px;  text-align: center;"  >Seat Map</th>
                                
                                <!-- <th *ngIf="!showSeatSelection"  style="cursor: pointer;color: #44a2f7;padding: 8px;  text-align: right;" (click)="seatWindow()">Seat Selection </th>
                                <th *ngIf="showSeatSelection"  style="cursor: pointer;color: #44a2f7;padding: 8px;  text-align: right;" > <div class="d-flex justify-content-end">Seat Selection  <mat-spinner class="mt-1"  diameter="15" ></mat-spinner></div></th> -->
    
    
    
                              </tr>
                            </thead>
                            <tbody>
                              <!-- Iterate through dynamic data rows -->
    
                                    <ng-container></ng-container>

                              <tr *ngFor="let con of flightMealDetails; let i=index">
                                <td class=""style="padding: 8px;  text-align: center;" >
                               {{con?.passengerTitle}}  {{con?.firstName}}  {{con?.lastName}} <br>
                               {{con.passengerType==="ADT"?("Adult"):con.passengerType==="CHD"?("Child"):con.passengerType==="INF"?("Infant"):''}} {{i+1}}
                               <div style="padding: 4px;  text-align: center;  background-color: #f2f2f2;"><strong >Frequent Flyers</strong></div>
  
  
                               <div *ngFor="let iteList of con.list" class="input-with-icon mt-2  mb-2">
                                
                                <input  style="padding-left: 32px;" class="form-control" type="text" maxlength="35" (keypress)="onlyNumberKey($event)" [(ngModel)]="iteList.flight.flightDetailsList[0].loyaltyNumber" [ngModelOptions]="{standalone: true}">
                                <img class="carrier-flogo" [src]="flightlogoFilter(iteList?.flight?.flightDetailsList[0]?.carrierName)"  alt="">
                              </div>
                            <span *ngIf="false">

                              <mat-divider *ngIf="returnFlights"></mat-divider>
  
                              <div *ngIf="returnFlights" class="input-with-icon mt-2 mb-2">
                                <input  style="padding-left: 32px;" class="form-control" type="text" maxlength="35"  (keypress)="onlyNumberKey($event)" [(ngModel)]="con.returnFlights.flightDetailsList[0].loyaltyNumber" [ngModelOptions]="{standalone: true}">
                                <img class="carrier-flogo" [src]="flightlogoFilter(con?.returnFlights?.flightDetailsList[0]?.carrierName)"  alt="">
  
                              </div>
                              <mat-divider *ngIf="thirdFlights"></mat-divider>
                                <div *ngIf="thirdFlights" class="input-with-icon mt-2 mb-2">
                                <input  style="padding-left: 32px;" class="form-control" type="text"  maxlength="35" (keypress)="onlyNumberKey($event)" [(ngModel)]="con.thirdFlights.flightDetailsList[0].loyaltyNumber"[ngModelOptions]="{standalone: true}" >
                                <img class="carrier-flogo" [src]="flightlogoFilter(con?.thirdFlights?.flightDetailsList[0]?.carrierName)"  alt="">
  
                              </div>
                              <mat-divider *ngIf="fourthFlights"></mat-divider>
  
                                <div *ngIf="fourthFlights" class="input-with-icon mt-2">
                                <input  style="padding-left: 32px;" class="form-control" type="text"  maxlength="35" (keypress)="onlyNumberKey($event)" [(ngModel)]="con.fourthFlights.flightDetailsList[0].loyaltyNumber" [ngModelOptions]="{standalone: true}">
                                <img class="carrier-flogo" [src]="flightlogoFilter(con?.fourthFlights?.flightDetailsList[0]?.carrierName)"  alt="">
  
                              </div>
                            </span>
                              </td>
                                <td class=""style="padding: 8px;  text-align: center;" >
                                 <!--#################### Sector ##################-->
                                 <!--#################### Sector ##################-->
                                <!--#################### Sector ##################-->
                                <!--#################### Sector ##################-->
  
                                <table class="styled-inner-tables ">  
                                                          
                                  <tbody>
                                 <ng-container *ngFor="let iteList of con.list">
                                    <tr *ngFor="let item of iteList.flight?.flightDetailsList;let j=index">
                                      
                                    <td class="name-type" style="padding: 8px;">
                                      <div class="flight-details">
                                        <img class="carrier-logo" [src]="flightlogoFilter(item?.carrierName)"  alt="">
                  
                                         
                                        <div class="carrier-info">
                                          <div class="flight-number">{{cityFilter(item?.fromAirport) }}- {{cityFilter(item?.toAirport)}}</div>
                                          <div>{{ fligthNameFilter(item?.carrierName )}}</div>
                                          <div class="flight-number">{{ item?.carrierName }} - {{ item?.flightNumber }}</div>
                                        </div>
                                      </div></td>
                                   
    
                                    </tr>
                                    </ng-container>
                                    <span *ngIf="false">
                                    <tr *ngFor="let item of returnFlights?.flightDetailsList;let j=index">
                                      <td  class="name-type" style="padding: 8px;">
                                        <div class="flight-details">
                                          <img class="carrier-logo" [src]="flightlogoFilter(item?.carrierName)"  alt="">
                    
                                           
                                          <div class="carrier-info">
                                            <div class="flight-number">{{cityFilter(item?.fromAirport) }}- {{cityFilter(item?.toAirport)}}</div>
                                            <div>{{ fligthNameFilter(item?.carrierName )}}</div>
                                            <div class="flight-number">{{ item?.carrierName }} - {{ item?.flightNumber }}</div>
                                          </div>
                                        </div>
                                      </td>
                                     
      
                                      </tr>
                                      <tr *ngFor="let item of thirdFlights?.flightDetailsList;let j=index">
                                        <td  class="name-type" style="padding: 8px;">
                                          <div class="flight-details">
                                            <img class="carrier-logo" [src]="flightlogoFilter(item?.carrierName)"  alt="">
                      
                                             
                                            <div class="carrier-info">
                                              <div class="flight-number">{{cityFilter(item?.fromAirport) }}- {{cityFilter(item?.toAirport)}}</div>
                                              <div>{{ fligthNameFilter(item?.carrierName )}}</div>
                                              <div class="flight-number">{{ item?.carrierName }} - {{ item?.flightNumber }}</div>
                                            </div>
                                          </div>
                                        </td>
                                       
        
                                        </tr>
                                        <tr *ngFor="let item of fourthFlights?.flightDetailsList;let j=index">
                                          <td  class="name-type" style="padding: 8px;">
                                            <div class="flight-details">
                                              <img class="carrier-logo" [src]="flightlogoFilter(item?.carrierName)"  alt="">
                        
                                               
                                              <div class="carrier-info">
                                                <div class="flight-number">{{cityFilter(item?.fromAirport) }}- {{cityFilter(item?.toAirport)}}</div>
                                                <div>{{ fligthNameFilter(item?.carrierName )}}</div>
                                                <div class="flight-number">{{ item?.carrierName }} - {{ item?.flightNumber }}</div>
                                              </div>
                                            </div>
                                          </td>
                                         
          
                                          </tr>
                                          </span>
                                  
                                  
                                  </tbody>
                                </table>
                                
                              </td>
    
                              <td class=""style="padding: 8px;  text-align: center;" >
                                <!--#################### meal ##################-->
                                <!--#################### meal ##################-->
                                <!--#################### meal ##################-->
                                <!--#################### meal ##################-->
                              <table class="styled-inner-tables ">  
                                                        
                                <tbody>
                                 <ng-container *ngFor="let iteList of con.list">

                                  <tr *ngFor="let item of iteList.flight.flightDetailsList;let j=index">
                                    
                                 
                                  <td class="" style="padding: 8px;" >
                                    <mat-select matNativeControl *ngIf="iteList.flight.source==='GALELIO'" (selectionChange)="mealSeatPriceTotal()"  class="form-control" [(ngModel)]="item.meal"  [ngModelOptions]="{standalone: true}" name="{{ 'meal' + (j+1) + (i+1) }}">
                                      <mat-option class="mat-primary "   *ngFor="let meal of item?.tag" [value]="{meal:meal.meal_code,baseFare:meal.dom_meal_price}">{{meal.meal_code}}{{meal.meal_desc?('('+meal.meal_desc+')'):''}} {{meal.dom_meal_price>0?('₹'+meal.dom_meal_price):''}}</mat-option>
                       
                                    </mat-select> 
  
                                    
                                    <mat-select matNativeControl *ngIf="iteList.flight.source!='GALELIO'" (selectionChange)="mealSeatPriceTotal()" (click)="onClickMeal(item,iteList.flight)" class="form-control" [(ngModel)]="item.meal"  [ngModelOptions]="{standalone: true}" name="{{ 'meal' + (j+1) + (i+1) }}">
                                      <mat-option  class="mat-primary " >--
                                        <small *ngIf="showSpiner"  style="cursor: pointer;color: #44a2f7;padding: 8px;  text-align: right;" > <div class="d-flex justify-content-end">  <mat-spinner class="mt-1"  diameter="15" ></mat-spinner></div></small>
  
                                      </mat-option>
                                      <mat-option class="mat-primary "   *ngFor="let meal of item.mealData" [value]="{ meal: meal.code, baseFare: meal.baseFare }">{{meal.code}}{{meal.description?('('+meal.description+')'):''}} {{meal.baseFare>0?('₹'+meal.baseFare):''}}</mat-option>
                       
                                    </mat-select> 
                                   </td>
    
                                  </tr>
                                  </ng-container>
                                  <span *ngIf="false">
                                  <tr *ngFor="let item of  con.returnFlights?.flightDetailsList; let j=index">
                                    
                                    <td class="" style="padding: 8px;">
                                        <mat-select *ngIf="con.returnFlights.source==='GALELIO'" (selectionChange)="mealSeatPriceTotal()" matNativeControl  class="form-control" [(ngModel)]="item.meal" name="{{'mealR'+(j+1)+(i+1)}}"  [ngModelOptions]="{standalone: true}">
                                          <mat-option class="mat-primary " *ngFor="let meal of item?.tag" [value]="{meal:meal.meal_code,baseFare:meal.dom_meal_price}">{{meal.meal_code}}{{meal.meal_desc?('('+meal.meal_desc+')'):''}} {{meal.dom_meal_price>0?('₹'+meal.dom_meal_price):''}}</mat-option>
                           
                                        </mat-select> 
                                        <mat-select *ngIf="con.returnFlights.source!='GALELIO'" (selectionChange)="mealSeatPriceTotal()" (click)="onClickMeal(item,con.returnFlights)"  matNativeControl   class="form-control" [(ngModel)]="item.meal" name="{{'mealR'+(j+1)+(i+1)}}"  [ngModelOptions]="{standalone: true}">
                                          <mat-option  class="mat-primary " >--
                                            <small *ngIf="showSpiner"  style="cursor: pointer;color: #44a2f7;padding: 8px;  text-align: right;" > <div class="d-flex justify-content-end">  <mat-spinner class="mt-1"  diameter="15" ></mat-spinner></div></small>
      
                                          </mat-option>
                                          <mat-option class="mat-primary " *ngFor="let meal of item.mealData" [value]="{ meal: meal.code, baseFare: meal.baseFare }">{{meal.code}}{{meal.description?('('+meal.description+')'):''}} {{meal.baseFare>0?('₹'+meal.baseFare):''}}</mat-option>
                           
                                        </mat-select> 
                                      
                                    </td>
    
                                    </tr>
                                
                                    <tr *ngFor="let item of  con.thirdFlights?.flightDetailsList; let j=index">
                                    
                                      <td class="" style="padding: 8px;">
                                          <mat-select *ngIf="con.thirdFlights.source==='GALELIO'" (selectionChange)="mealSeatPriceTotal()" matNativeControl  class="form-control" [(ngModel)]="item.meal" name="{{'mealR'+(j+1)+(i+1)}}"  [ngModelOptions]="{standalone: true}">
                                            <mat-option class="mat-primary " *ngFor="let meal of item?.tag" [value]="{meal:meal.meal_code,baseFare:meal.dom_meal_price}">{{meal.meal_code}}{{meal.meal_desc?('('+meal.meal_desc+')'):''}} {{meal.dom_meal_price>0?('₹'+meal.dom_meal_price):''}}</mat-option>
                             
                                          </mat-select>
                                          <mat-select *ngIf="con.thirdFlights.source!='GALELIO'" (selectionChange)="mealSeatPriceTotal()" (click)="onClickMeal(item,con.thirdFlights)" matNativeControl  class="form-control" [(ngModel)]="item.meal" name="{{'mealR'+(j+1)+(i+1)}}"  [ngModelOptions]="{standalone: true}">
                                            <mat-option  class="mat-primary " >--
                                              <small  *ngIf="showSpiner" style="cursor: pointer;color: #44a2f7;padding: 8px;  text-align: right;" > <div class="d-flex justify-content-end">  <mat-spinner class="mt-1"  diameter="15" ></mat-spinner></div></small>
        
                                            </mat-option>
                                            <mat-option class="mat-primary " *ngFor="let meal of item.mealData" [value]="{ meal: meal.code, baseFare: meal.baseFare }">{{meal.code}}{{meal.description?('('+meal.description+')'):''}} {{meal.baseFare>0?('₹'+meal.baseFare):''}}</mat-option>
                             
                                          </mat-select> 
                                        
                                      </td>
      
                                      </tr>
                                      <tr *ngFor="let item of  con.fourthFlights?.flightDetailsList; let j=index">
                                    
                                        <td class="" style="padding: 8px;">
                                            <mat-select *ngIf="con.fourthFlights.source==='GALELIO'" (selectionChange)="mealSeatPriceTotal()" matNativeControl  class="form-control" [(ngModel)]="item.meal" name="{{'mealR'+(j+1)+(i+1)}}"  [ngModelOptions]="{standalone: true}">
                                              <mat-option class="mat-primary " *ngFor="let meal of item?.tag" [value]="{meal:meal.meal_code,baseFare:meal.dom_meal_price}">{{meal.meal_code}}{{meal.meal_desc?('('+meal.meal_desc+')'):''}} {{meal.dom_meal_price>0?('₹'+meal.dom_meal_price):''}}</mat-option>
                               
                                            </mat-select>
                                            <mat-select *ngIf="con.fourthFlights.source!='GALELIO'" matNativeControl (selectionChange)="mealSeatPriceTotal()" (click)="onClickMeal(item,con.fourthFlights)"  class="form-control" [(ngModel)]="item.meal" name="{{'mealR'+(j+1)+(i+1)}}"  [ngModelOptions]="{standalone: true}">
                                              <mat-option  class="mat-primary " >--
                                                <small  *ngIf="showSpiner" style="cursor: pointer;color: #44a2f7;padding: 8px;  text-align: right;" > <div class="d-flex justify-content-end">  <mat-spinner class="mt-1"  diameter="15" ></mat-spinner></div></small>
          
                                              </mat-option>
                                              <mat-option class="mat-primary " *ngFor="let meal of item.mealData" [value]="{ meal: meal.code, baseFare: meal.baseFare }">{{meal.code}}{{meal.description?('('+meal.description+')'):''}} {{meal.baseFare>0?('₹'+meal.baseFare):''}}</mat-option>
                               
                                            </mat-select> 
                                          
                                        </td>
        
                                        </tr>
                                        </span>
                                
                                </tbody>
                              </table>
                              
                            </td>
                            <td class=""style="padding: 8px;  text-align: center;" >
                               <!--#################### seat ##################-->
                                <!--#################### seat ##################-->
                                <!--#################### seat ##################-->
                                <!--#################### seat ##################-->
                              <table class="styled-inner-tables ">  
                                                        
                                <tbody>
                                  <ng-container *ngFor="let iteList of con.list">
                                  <tr *ngFor="let item of iteList?.flight?.flightDetailsList ;let j=index">
                                    
                                  
                                 
                                  <td class="" style="padding: 8px;">
                                    <div class="input-with-icon">
                                      
                                        <p-button (click)="op.toggle($event)" icon="pi pi-share-alt" label="Seat Info" />
                                        <p-overlayPanel #op >
                                            <div class="col-md-12 ">
                                              <!-- <div class="col-md-6"> -->
                                                <label for="Seat">Seat</label>

                                                <input   class="form-control" placeholder="Seat "  [(ngModel)]="item.seat"  name="{{'seat1'+(j+1)+(i+1)}}"  [ngModelOptions]="{standalone: true}"      type="text">

                                              <!-- </div> -->
                                              <!-- <div class="col-md-6"> -->
                                                <label for="Seat Price">Seat Price</label>
                                                <input  class="form-control" placeholder="Seat Price"  (keypress)="onlyNumberKey($event)" [(ngModel)]="item.seatPrice" (input)="mealSeatPriceTotal()"  name="{{'seat1'+(j+1)+(i+1)}}"  [ngModelOptions]="{standalone: true}"      type="text">

                                              <!-- </div> -->

                                                </div>
                                               
                                        </p-overlayPanel>



                                <small *ngIf="item.showSeatSelection"  style="cursor: pointer;color: #44a2f7;padding: 8px;  text-align: right;" > <div class="d-flex justify-content-end">  <mat-spinner class="mt-1"  diameter="15" ></mat-spinner></div></small>
    
                              </div>
                                  
                                  </td>
    
                                  </tr>
                                  </ng-container>
                                  <span *ngIf="false">
                                  <tr *ngFor="let item of con.returnFlights?.flightDetailsList;let j=index">
                                   
                                   
                                    <td class="" style="padding: 8px;">
                                      <div class="input-with-icon">
                                        <p-button (click)="op.toggle($event)" icon="pi pi-share-alt" label="Seat Info" />
                                        <p-overlayPanel #op >
                                            <div class="col-md-12 ">
                                              <!-- <div class="col-md-6"> -->
                                                <label for="Seat">Seat</label>

                                                <input  class="form-control" placeholder="Select Seat" [(ngModel)]="item.seat" name="{{'seat2'+(j+1)+(i+1)}}"  [ngModelOptions]="{standalone: true}"    type="text">

                                              <!-- </div> -->
                                              <!-- <div class="col-md-6"> -->
                                                <label for="Seat Price">Seat Price</label>
                                                <input  class="form-control" placeholder="Select Seat" [(ngModel)]="item.seatPrice" (input)="mealSeatPriceTotal()"  name="{{'seat2'+(j+1)+(i+1)}}"  [ngModelOptions]="{standalone: true}"    type="text">


                                              <!-- </div> -->

                                                </div>
                                               
                                        </p-overlayPanel>
                                    <small *ngIf="item.showSeatSelection"  style="cursor: pointer;color: #44a2f7;padding: 8px;  text-align: right;" > <div class="d-flex justify-content-end">  <mat-spinner class="mt-1"  diameter="15" ></mat-spinner></div></small>
        
                                  </div>
                                    
                                    </td>
    
                                    </tr>
                                    <tr *ngFor="let item of con.thirdFlights?.flightDetailsList;let j=index">
                                   
                                   
                                      <td class="" style="padding: 8px;">
                                        <div class="input-with-icon">

                                          <p-button (click)="op.toggle($event)" icon="pi pi-share-alt" label="Seat Info" />
                                          <p-overlayPanel #op >
                                              <div class="col-md-12 ">
                                                <!-- <div class="col-md-6"> -->
                                                  <label for="Seat">Seat</label>
                                                  <input  class="form-control" placeholder="Select Seat" [(ngModel)]="item.seat" name="{{'seat3'+(j+1)+(i+1)}}"  [ngModelOptions]="{standalone: true}"  type="text">

  
                                                <!-- </div> -->
                                                <!-- <div class="col-md-6"> -->
                                                  <label for="Seat Price">Seat Price</label>
                                                  <input  class="form-control" placeholder="Select Seat" [(ngModel)]="item.seatPrice" (input)="mealSeatPriceTotal()" name="{{'seat3'+(j+1)+(i+1)}}"  [ngModelOptions]="{standalone: true}"  type="text">

  
  
                                                <!-- </div> -->
  
                                                  </div>
                                                 
                                          </p-overlayPanel>

                                      <small *ngIf="item.showSeatSelection"  style="cursor: pointer;color: #44a2f7;padding: 8px;  text-align: right;" > <div class="d-flex justify-content-end">  <mat-spinner class="mt-1"  diameter="15" ></mat-spinner></div></small>
          
                                    </div>
                                      
                                      </td>
      
                                      </tr>
                                      <tr *ngFor="let item of con.fourthFlights?.flightDetailsList;let j=index">
                                   
                                   
                                        <td class="" style="padding: 8px;">
                                          <div class="input-with-icon">
                                            <p-button (click)="op.toggle($event)" icon="pi pi-share-alt" label="Seat Info" />
                                            <p-overlayPanel #op >
                                                <div class="col-md-12 ">
                                                  <!-- <div class="col-md-6"> -->
                                                    <label for="Seat">Seat</label>
                                                    <input  class="form-control" placeholder="Select Seat" [(ngModel)]="item.seat" name="{{'seat4'+(j+1)+(i+1)}}"  [ngModelOptions]="{standalone: true}"  type="text">
  
    
                                                  <!-- </div> -->
                                                  <!-- <div class="col-md-6"> -->
                                                    <label for="Seat Price">Seat Price</label>
                                                    <input  class="form-control" placeholder="Select Seat" [(ngModel)]="item.seatPrice" (input)="mealSeatPriceTotal()" name="{{'seat4'+(j+1)+(i+1)}}"  [ngModelOptions]="{standalone: true}"  type="text">

  
    
    
                                                  <!-- </div> -->
    
                                                    </div>
                                                   
                                            </p-overlayPanel>





                                        <small *ngIf="item.showSeatSelection"  style="cursor: pointer;color: #44a2f7;padding: 8px;  text-align: right;" > <div class="d-flex justify-content-end">  <mat-spinner class="mt-1"  diameter="15" ></mat-spinner></div></small>
            
                                      </div>
                                        
                                        </td>
        
                                        </tr>
                                </span>
                                
                                </tbody>
                              </table>
                              
                            </td>
    
                              </tr>
    
    
    
    
    
    
    
    
    
    
    
                              <!-- <tr *ngFor="let con of passengerDetails.controls; let i=index">
                                
                                <td class=""style="padding: 8px;  text-align: center;" >
                               {{con?.value?.passengerTitle}}  {{con?.value?.firstName}}  {{con?.value?.lastName}} <br>
                               Adult {{i+1}}
                                </td>
                                <table class="styled-tables ">  
                                  <thead>
                                    <tr >
                                      <th style="padding: 8px;  text-align: center;">Sector</th>
                                      <th style="padding: 8px;  text-align: center;">Meal Preference  </th>
                                      <th style="padding: 8px;  text-align: center;"  >Seat Map</th>
                                     
          
          
                                    </tr>
                                  </thead>                             
                                  <tbody>
                                    <tr *ngFor="let item of flights?.flightDetailsList">
                                      
                                    <td class="name-type" style="padding: 8px;">
                                      <div class="flight-details">
                                        <img class="carrier-logo" [src]="flightlogoFilter(item?.carrierName)"  alt="">
                  
                                         
                                        <div class="carrier-info">
                                          <div class="flight-number">{{cityFilter(item?.fromAirport) }}- {{cityFilter(item?.toAirport)}}</div>
                                          <div>{{ fligthNameFilter(item?.carrierName )}}</div>
                                          <div class="flight-number">{{ item?.carrierName }} - {{ item?.flightNumber }}</div>
                                        </div>
                                      </div></td>
                                    <td class="" style="padding: 8px;">
                                      <mat-select matNativeControl  class="form-control" >
                                        <mat-option class="mat-primary "   *ngFor="let meal of item?.tag" [value]="meal.meal_desc">{{meal.meal_desc +'('+meal.dom_meal_price+' INR)'}}</mat-option>
                         
                                      </mat-select> 
                                     </td>
                                    <td class="" style="padding: 8px;"><input class="form-control"  style="cursor: not-allowed;"  readonly type="text"></td>
    
                                    </tr>
                                    <tr *ngFor="let item of returnFlights?.flightDetailsList">
                                      <td  class="name-type" style="padding: 8px;">
                                        <div class="flight-details">
                                          <img class="carrier-logo" [src]="flightlogoFilter(item?.carrierName)"  alt="">
                    
                                           
                                          <div class="carrier-info">
                                            <div class="flight-number">{{cityFilter(item?.fromAirport) }}- {{cityFilter(item?.toAirport)}}</div>
                                            <div>{{ fligthNameFilter(item?.carrierName )}}</div>
                                            <div class="flight-number">{{ item?.carrierName }} - {{ item?.flightNumber }}</div>
                                          </div>
                                        </div>
                                      </td>
                                      <td class="" style="padding: 8px;">
                                          <mat-select matNativeControl  class="form-control">
                                            <mat-option class="mat-primary " *ngFor="let meal of item?.tag" [value]="meal.meal_desc">{{meal.meal_desc +'('+meal.dom_meal_price+' INR)'}}</mat-option>
                             
                                          </mat-select> 
                                        
                                      </td>
                                      <td class="" style="padding: 8px;"><input class="form-control" style="cursor: not-allowed;" readonly type="text"></td>
      
                                      </tr>
                                  
                                  
                                  </tbody>
                                </table>
    
                              </tr> -->
    <!-- 
                              <tr *ngFor="let con of passengerChild.controls; let i=index">
                                
                                <td class=""style="padding: 8px;  text-align: center;" >
                               {{con?.value?.passengerTitle}}  {{con?.value?.firstName}}  {{con?.value?.lastName}} <br>
                               Child {{i+1}}
                                </td>
                                <table class="styled-tables ">  
                                  <thead>
                                    <tr >
                                      <th style="padding: 8px;  text-align: center;">Sector</th>
                                      <th style="padding: 8px;  text-align: center;">Meal Preference  </th>
                                      <th style="padding: 8px;  text-align: center;"  >Seat Map</th>
                                     
          
          
                                    </tr>
                                  </thead>                             
                                  <tbody>
                                    <tr *ngFor="let item of flights?.flightDetailsList">
                                      
                                    <td class="name-type" style="padding: 8px;">
                                      <div class="flight-details">
                                        <img class="carrier-logo" [src]="flightlogoFilter(item?.carrierName)"  alt="">
                  
                                         
                                        <div class="carrier-info">
                                          <div class="flight-number">{{cityFilter(item?.fromAirport) }}- {{cityFilter(item?.toAirport)}}</div>
                                          <div>{{ fligthNameFilter(item?.carrierName )}}</div>
                                          <div class="flight-number">{{ item?.carrierName }} - {{ item?.flightNumber }}</div>
                                        </div>
                                      </div></td>
                                    <td class="" style="padding: 8px;">
                                      <mat-select matNativeControl  class="form-control" >
                                        <mat-option class="mat-primary "   *ngFor="let meal of item?.tag" [value]="meal.meal_desc">{{meal.meal_desc +'('+meal.dom_meal_price+' INR)'}}</mat-option>
                         
                                      </mat-select> 
                                     </td>
                                    <td class="" style="padding: 8px;"><input class="form-control" style="cursor: not-allowed;"  readonly type="text"></td>
    
                                    </tr>
                                    <tr *ngFor="let item of returnFlights?.flightDetailsList">
                                      <td  class="name-type" style="padding: 8px;">
                                        <div class="flight-details">
                                          <img class="carrier-logo" [src]="flightlogoFilter(item?.carrierName)"  alt="">
                    
                                           
                                          <div class="carrier-info">
                                            <div class="flight-number">{{cityFilter(item?.fromAirport) }}- {{cityFilter(item?.toAirport)}}</div>
                                            <div>{{ fligthNameFilter(item?.carrierName )}}</div>
                                            <div class="flight-number">{{ item?.carrierName }} - {{ item?.flightNumber }}</div>
                                          </div>
                                        </div>
                                      </td>
                                      <td class="" style="padding: 8px;">
                                          <mat-select matNativeControl  class="form-control">
                                            <mat-option class="mat-primary " *ngFor="let meal of item?.tag" [value]="meal.meal_desc">{{meal.meal_desc +'('+meal.dom_meal_price+' INR)'}}</mat-option>
                             
                                          </mat-select> 
                                        
                                      </td>
                                      <td class="" style="padding: 8px;"><input class="form-control" style="cursor: not-allowed;" readonly type="text"></td>
      
                                      </tr>
                                  
                                  
                                  </tbody>
                                </table>
    
                              </tr> -->
                              <!-- <tr *ngFor="let con of passengerInfent.controls; let i=index">
                                
                                <td class=""style="padding: 8px;  text-align: center;" >
                               {{con?.value?.passengerTitle}}  {{con?.value?.firstName}}  {{con?.value?.lastName}} <br>
                               Infant {{i+1}}
                                </td>
                                <table class="styled-tables ">  
                                  <thead>
                                    <tr >
    \                                  <th style="padding: 8px;  text-align: center;">Sector</th>
                                      <th style="padding: 8px;  text-align: center;">Meal Preference  </th>
                                      <th style="padding: 8px;  text-align: center;"  >Seat Map</th>
                                     
          
          
                                    </tr>
                                  </thead>                             
                                  <tbody>
    \                                <tr *ngFor="let item of flights?.flightDetailsList">
                                      
                                    <td class="name-type" style="padding: 8px;">
                                      <div class="flight-details">
                                        <img class="carrier-logo" [src]="flightlogoFilter(item?.carrierName)"  alt="">
                  
                                         
                                        <div class="carrier-info">
                                          <div class="flight-number">{{cityFilter(item?.fromAirport) }}- {{cityFilter(item?.toAirport)}}</div>
                                          <div>{{ fligthNameFilter(item?.carrierName )}}</div>
                                          <div class="flight-number">{{ item?.carrierName }} - {{ item?.flightNumber }}</div>
                                        </div>
                                      </div></td>
                                    <td class="" style="padding: 8px;">
                                      <mat-select matNativeControl  class="form-control" >
                                        <mat-option class="mat-primary "   *ngFor="let meal of item?.tag" [value]="meal.meal_desc">{{meal.meal_desc +'('+meal.dom_meal_price+' INR)'}}</mat-option>
                         
                                      </mat-select> 
                                     </td>
                                    <td class="" style="padding: 8px;"><input class="form-control" style="cursor: not-allowed;"  readonly type="text"></td>
    
                                    </tr>
                                    <tr *ngFor="let item of returnFlights?.flightDetailsList">
                                      <td  class="name-type" style="padding: 8px;">
                                        <div class="flight-details">
                                          <img class="carrier-logo" [src]="flightlogoFilter(item?.carrierName)"  alt="">
                    
                                           
                                          <div class="carrier-info">
                                            <div class="flight-number">{{cityFilter(item?.fromAirport) }}- {{cityFilter(item?.toAirport)}}</div>
                                            <div>{{ fligthNameFilter(item?.carrierName )}}</div>
                                            <div class="flight-number">{{ item?.carrierName }} - {{ item?.flightNumber }}</div>
                                          </div>
                                        </div>
                                      </td>
                                      <td class="" style="padding: 8px;">
                                          <mat-select matNativeControl  class="form-control">
                                            <mat-option class="mat-primary " *ngFor="let meal of item?.tag" [value]="meal.meal_desc">{{meal.meal_desc +'('+meal.dom_meal_price+' INR)'}}</mat-option>
                             
                                          </mat-select> 
                                        
                                      </td>
                                      <td class="" style="padding: 8px;"><input class="form-control" style="cursor: not-allowed;" readonly type="text"></td>
      
                                      </tr>
                                  
                                  
                                  </tbody>
                                </table>
    
                              </tr> -->
                            </tbody>
                          </table>
    
    
                </div> 
    
    
    
                 
                    
                      <mat-divider class="mt-2"></mat-divider>
      
                      <div class="mt-2">
                        <button *ngIf="!swingOrderId" mat-raised-button color="accent" (click)=" bookflight()">Continue to payment</button>
                        <button  *ngIf="swingOrderId"  mat-raised-button color="accent" style="margin-right: 2%; width: 100px;"  ><mat-spinner  diameter="30" ></mat-spinner></button>
    
                      </div>
                    </form>
                  </mat-step>
              </mat-stepper>
            </div>
            <div *ngIf="paymentDetail "  [class]="showSideBar?('col-md-12'):'col-md-9'">
            
              <app-manual-payment-detail (myOutput)="backClick()"  (hideSideBar)="hideSideBar()"></app-manual-payment-detail>
    
            </div>
             <!-- <div *ngIf="paymentDetail && showSideBar" class="col-md-12 ">
            
              <app-payment-details (myOutput)="backClick()"  (hideSideBar)="hideSideBar()"></app-payment-details>
    
            </div> -->
            <div  *ngIf="!showSideBar" class="col-md-3" style="background-color: #d2e1f5; border-radius: 4px; content: right; height: 85vh; overflow-y: auto;">
    
    
              <!-- trip-details.component.html -->
    
    <div class="trip-details-container">
    
    
      <div *ngIf="hideAdvancePricing" class="panel mt-3" (click)="togglePanel('advancePrice')">
        <div  class="flex flex-middle flex-between row pt-1 " style="background-color: #1876D1; border-radius: 4px; min-height:30px ;color:white" >
         <div class="col-md-12 input-with-icon" (click)="OnSidebarClick()">
          <span class="fs-5 col-md-6  ">
            <div  class="col-md-12 d-flex justify-content-start bold" style="font-size: 18px;"> 
               Advanced Pricing
            </div>
          </span>
    
          <mat-icon style="font-size: 18px;">open_with</mat-icon>
        </div>
       
        </div> 
      
        <!-- <div *ngIf="expandedPanel === 'advancePrice'" class="panel-content">
        <span  >
          <table  class="styled-tables col-md-12">
            <thead>
              <tr >
                <th style="padding: 8px;  text-align: center;">Base   </th>
                <th style="padding: 8px;  text-align: center;">Tax  </th>
                <th style="padding: 8px;  text-align: center;">Fee  </th>
    
    
    
              </tr>
            </thead>
            <tbody>
              <tr >
               
                <td  style="padding: 8px;">{{''}}</td>
                <td  style="padding: 8px;">{{''}}</td>
                <td  style="padding: 8px;">{{''}}</td>
              
    
              </tr>
              
              
            </tbody>
          </table>
        </span>
    
        </div> -->
      
      </div>
    
    
    
    
    <!--+++++++++++++++++++++++++++++++++++ Price Details ++++++++++++++++++++++++++-->
    <!--+++++++++++++++++++++++++++++++++++ Price Details ++++++++++++++++++++++++++-->
    <!--+++++++++++++++++++++++++++++++++++ Price Details ++++++++++++++++++++++++++-->
    <!--+++++++++++++++++++++++++++++++++++ Price Details ++++++++++++++++++++++++++-->
    <!--+++++++++++++++++++++++++++++++++++ Price Details ++++++++++++++++++++++++++-->
    <!--+++++++++++++++++++++++++++++++++++ Price Details ++++++++++++++++++++++++++-->
    
      <div class="panel mt-1" >
        <div (click)="togglePanel('totalPrice')" class="flex flex-middle flex-between row pt-2 " style="background-color: #1876D1; border-radius: 4px; min-height:50px ;color:white" >
         <div class="col-md-12 input-with-icon">
          <span class="fs-5 col-md-6  ">Total price</span>
          <span *ngIf="travelType==='AD'" class="col-md-6 spanTotal pb-1 pt-1">{{fare?.totalPrice?(advanceTotal+totalSeatPrice+totalMealPrice+fare?.totalPrice+fare?.totalTax+totalCommercialAmount+(returnFlights?(totalCommercialAmount):0)+(thirdFlights?(totalCommercialAmount):0)+(fourthFlights?(totalCommercialAmount):0)):flights?.fare[0]?.baseFare+flights?.fare[0]?.finalTax+totalCommercialAmount+(returnFlights?.fare[0]?(returnFlights.fare[0]?.baseFare+returnFlights?.fare[0]?.finalTax+totalCommercialAmount):0)}} INR</span>
          <span *ngIf="travelType==='AI'" class="col-md-6 spanTotal pb-1 pt-1">
            {{fare?.totalPrice?(advanceTotal+totalSeatPrice+totalMealPrice+fare?.totalPrice+fare?.totalTax+totalCommercialAmount):
              flights?.fare[0]?.baseFare+flights?.fare[0]?.finalTax+totalCommercialAmount+(returnFlights?.fare[0]?(returnFlights.fare[0]?.baseFare+returnFlights?.fare[0]?.finalTax+totalCommercialAmount):0)}} INR</span>
  
          <mat-icon *ngIf="expandedPanel === 'totalPrice'">keyboard_arrow_up</mat-icon>
    
          <mat-icon *ngIf="expandedPanel != 'totalPrice'">keyboard_arrow_down</mat-icon>
        </div>
        </div>    <div *ngIf="expandedPanel === 'totalPrice'" class="panel-content">
          <div class="col-md-12">
            <div class="flexflex-between flex-row"></div>
           
            <div *ngIf="!orderboolean" class="mt-2 row" style="font-size: 12px; ">
          <span class="col-md-8 pt-1">Base fare ({{travellerDetail?.adult+travellerDetail?.child+travellerDetail?.infantCount}} {{travellerS}})</span>
    
              <span class="col-md-4 pb-1 pt-1">{{fare?.totalPrice||flights?.fare[0]?.baseFare+returnFlights?.fare[0]?.baseFare}} INR</span>
               <mat-divider></mat-divider>
              <span class="col-md-8 pb-1 pt-1">Airline Taxes</span>
              <span class="col-md-4 pb-1 pt-1">{{fare?.totalTax||flights?.fare[0]?.finalTax+returnFlights?.fare[0]?.finalTax}} INR</span>
              <mat-divider></mat-divider>
            
              
              <span class="col-md-8 pb-1 pt-1">Total Price</span>
              <span class="col-md-4 pb-1 pt-1">{{fare?.totalPrice+fare?.totalTax||flights?.fare[0]?.baseFare+flights?.fare[0]?.finalTax+returnFlights?.fare[0]?.baseFare+returnFlights?.fare[0]?.finalTax}} INR</span>
    
    
            </div>
            <div *ngIf="orderboolean"  class="mt-2 row"  style="font-size: 12px; ">
              <span class="col-md-8 pt-1">Base fare ({{travellerDetail?.adult+travellerDetail?.child+travellerDetail?.infantCount}} {{travellerS}})</span>
    
              <span class="col-md-4 pb-1 pt-1">{{fare?.totalPrice||flights?.fare[0]?.baseFare+returnFlights?.fare[0]?.baseFare}} INR</span>
               <mat-divider></mat-divider>
              <span class="col-md-8 pb-1 pt-1">Airline Taxes </span>
              <span class="col-md-4 pb-1 pt-1">{{fare?.totalTax||flights?.fare[0]?.finalTax+returnFlights?.fare[0]?.finalTax}} INR</span>
              <mat-divider></mat-divider>
            
             <div *ngFor="let item of  commercialFee" class=" row"> 
              <span class="col-md-8 pt-1 capitalize" >{{item?.key}}</span>
    
              <span *ngIf="travelType==='AD'" class="col-md-4 pb-1 pt-1 d-flex justify-content-center" >{{item?.value?.value?(item?.value?.value+(returnFlights?.fare[0]?(item?.value?.value):0)+(thirdFlights?.fare[0]?(item?.value?.value):0)+(fourthFlights?.fare[0]?(item?.value?.value):0)+' INR'):''}} </span> 
              <span *ngIf="travelType==='AI'" class="col-md-4 pb-1 pt-1 d-flex justify-content-center" >{{item?.value?.value?(item?.value?.value+' INR'):''}} </span> 

              <div class="col-md-12 Grouping-data " >
             <div  *ngFor="let element of item?.value?.taxes" class="col-md-12  row">
              <mat-icon class="col-md-1 mt-2" style="color:#44a2f7">maximize</mat-icon>
    
              <span class="col-md-5 pt-1 capitalize" >{{element?.label}}</span>
    
              <span *ngIf="travelType==='AD'" class="col-md-3 pb-1 pt-1 d-flex justify-content-start" >{{element?.amount?(element?.amount+(returnFlights?.fare[0]?(element?.amount):0)+(thirdFlights?.fare[0]?(element?.amount):0)+(fourthFlights?.fare[0]?(element?.amount):0)+' INR'):'0 INR'}}  </span> 
              <span *ngIf="travelType==='AI'" class="col-md-3 pb-1 pt-1 d-flex justify-content-start" >{{element?.amount?(element?.amount+' INR'):'0 INR'}}  </span> 

            </div>
            </div>
    
             <span class="col-md-8  capitalize" >{{''}}
    
             </span>
    
     
             <span *ngIf="travelType==='AD'" class="col-md-4 pb-1   d-flex justify-content-center" >
              {{item?.value?.totalValue?(item?.value?.totalValue+(returnFlights?.fare[0]?(item?.value?.totalValue):0)+(thirdFlights?.fare[0]?(item?.value?.totalValue):0)+(fourthFlights?.fare[0]?(item?.value?.totalValue):0)+' INR'):''}} 
             </span>
             <span *ngIf="travelType==='AI'" class="col-md-4 pb-1   d-flex justify-content-center" >
              {{item?.value?.totalValue?(item?.value?.totalValue+' INR'):''}} 
             </span>
             <mat-divider></mat-divider>
             </div>
           
             <span class="col-md-8  bold pt-1" style="color:#44a2f7;cursor: pointer;" >Advanced Pricing</span>
             <span class="col-md-4 pb-1 pt-1" >{{advanceTotal}} INR</span>
             <span class="col-md-8  bold pt-1" style="color:#44a2f7;cursor: pointer;" >Seat Price</span>
             <span class="col-md-4 pb-1 pt-1" >{{totalSeatPrice}} INR</span>
             <span class="col-md-8  bold pt-1" style="color:#44a2f7;cursor: pointer;" >Meal Price</span>
             <span class="col-md-4 pb-1 pt-1" >{{totalMealPrice}} INR</span>
             <mat-divider></mat-divider>
              <span class="col-md-8  pt-1">Total Price</span>
              <span *ngIf="travelType==='AD'"  class="col-md-4 pb-1 pt-1">{{fare?.totalPrice?(advanceTotal+totalSeatPrice+totalMealPrice+fare?.totalPrice+fare?.totalTax+totalCommercialAmount+(returnFlights?(totalCommercialAmount):0)+(thirdFlights?(totalCommercialAmount):0)+(fourthFlights?(totalCommercialAmount):0)):flights?.fare[0]?.baseFare+flights?.fare[0]?.finalTax+totalCommercialAmount+(returnFlights?.fare[0]?(returnFlights.fare[0]?.baseFare+returnFlights?.fare[0]?.finalTax+totalCommercialAmount):0)}} INR</span>
              <span *ngIf="travelType==='AI'" class="col-md-4 pb-1 pt-1">
                {{fare?.totalPrice?(advanceTotal+totalSeatPrice+totalMealPrice+fare?.totalPrice+fare?.totalTax+totalCommercialAmount)
                  :flights?.fare[0]?.baseFare+flights?.fare[0]?.finalTax+totalCommercialAmount+(returnFlights?.fare[0]?(returnFlights.fare[0]?.baseFare+returnFlights?.fare[0]?.finalTax+totalCommercialAmount):0)+totalSeatPrice}} INR</span>
  
            </div>
            
    
          </div>
        </div>
      </div>
    
    <!--+++++++++++++++++++++++++++++++++++ flights Details ++++++++++++++++++++++++++-->
    <!--+++++++++++++++++++++++++++++++++++ flights Details ++++++++++++++++++++++++++-->
    <!--+++++++++++++++++++++++++++++++++++ flights Details ++++++++++++++++++++++++++-->
    <!--+++++++++++++++++++++++++++++++++++ flights Details ++++++++++++++++++++++++++-->
    <!--+++++++++++++++++++++++++++++++++++ flights Details ++++++++++++++++++++++++++-->
    <!--+++++++++++++++++++++++++++++++++++ flights Details ++++++++++++++++++++++++++-->
    
    <!--+++++++++++++++++++++++++++++++++++ flights  ++++++++++++++++++++++++++-->
    <!--+++++++++++++++++++++++++++++++++++ flights  ++++++++++++++++++++++++++-->
    <!--+++++++++++++++++++++++++++++++++++ flights  ++++++++++++++++++++++++++-->
      <div *ngFor="let flightIte of flighItiList" class="panel mt-3"  (click)="togglePanel('itinerary')">
        <div class=" flex flex-middle flex-between   row" style="background-color: #1876D1; border-radius: 4px;min-height:50px;color:white"> 
          <div class="col-md-4 "><div class="col-md-12 bold d-flex justify-content-start">{{flightIte?.flightDetailsList[0]?.fromAirport}}</div><div class="col-md-12 justify-content-start">{{cityFilter(flightIte?.flightDetailsList[0]?.fromAirport)}}</div></div>
          <div class="col-md-4  d-flex justify-content-center "> <mat-icon class="mt-2">flight_takeoff</mat-icon></div>
    
        <div class="col-md-4   "><div class="col-md-12 bold d-flex justify-content-end">{{flightIte?.flightDetailsList[flightIte?.flightDetailsList.length-1]?.toAirport}}</div><div class="col-md-12 d-flex justify-content-end">{{cityFilter(flightIte?.flightDetailsList[flightIte?.flightDetailsList.length-1]?.toAirport)}}</div></div>
      </div>
       
    
        <div  class="panel-content">
          <div class="flights " >
    
            <div class="col-md-12 row"> 
              <div class="col-md-4 ">
                <div class="col-md-12 bold d-flex justify-content-start">
                  <img class="carrier-logo"  [src]="flightlogoFilter(flightIte?.flightDetailsList[0]?.carrierName)"  alt="">
    
                
                </div>
               </div>
        
            <div class="col-md-6 "> <div class="col-md-12 justify-content-start">
              <div class="col-md-12 justify-content-start">{{fligthNameFilter(flightIte?.flightDetailsList[0]?.carrierName)}}</div>
    
              <div class="col-md-12 flight-number "> {{flightIte?.flightDetailsList[0]?.carrierName }} - {{ flightIte?.flightDetailsList[0]?.flightNumber }}</div>
    
            </div>
            
          </div>
          <mat-divider></mat-divider>
          <div class="col-md-12 flights " style="margin-top:0;padding-top: 0;">
            <div class="flight-number bold" style="color: #1876D1;"> Fare Type: </div>
             <div class="flight-number" style="color: #1876D1;">
              <!-- {{flights.fare[0]?.corporateFare?('Corporate'):flights.fare[0].fareType}} -->
              {{flightIte.fare[0]?.fareTypeDisplay}}
  
            </div>
           </div>
          </div>
         
          </div>
         
    
          
        </div>
      
        <div class="col-md-12 row"> 
          
          <div class="col-md-4 "><div class="col-md-12  d-flex justify-content-start" style="font-size: 10px;">{{dateFormate(flightIte?.flightDetailsList[0]?.schDepartureTime)}}</div><div class="col-md-12 bold d-flex justify-content-start">{{flightIte?.flightDetailsList[0]?.fromAirport}}</div><div class="col-md-12 justify-content-start">{{ timeFormate(flightIte?.flightDetailsList[0]?.schDepartureTime) }}</div><div class="col-md-12  d-flex justify-content-start">{{cityFilter(flightIte?.flightDetailsList[0]?.fromAirport)}}</div><div class="col-md-12 d-flex justify-content-start">{{flightIte?.flightDetailsList[0]?.fromTerminal?("Terminal&nbsp;"+flightIte?.flightDetailsList[0]?.fromTerminal):''}}</div></div>
          <div class="col-md-4  flight-number ">⌚ {{calculateDuration(flightIte?.flightDetailsList[flightIte?.flightDetailsList.length-1]?.schArrivalTime,flightIte?.flightDetailsList[0]?.schDepartureTime)}}</div>
    
        <div class="col-md-4   "><div class="col-md-12  d-flex justify-content-end" style="font-size: 10px;">{{dateFormate(flightIte?.flightDetailsList[flightIte?.flightDetailsList.length-1]?.schArrivalTime)}}</div><div class="col-md-12 bold d-flex justify-content-end">{{flightIte?.flightDetailsList[flightIte?.flightDetailsList.length-1]?.toAirport}}</div><div class="col-md-12 d-flex justify-content-end">{{ timeFormate(flightIte?.flightDetailsList[flightIte?.flightDetailsList.length-1]?.schArrivalTime)}}</div><div class="col-md-12  d-flex justify-content-end">{{cityFilter(flightIte?.flightDetailsList[flightIte?.flightDetailsList.length-1]?.toAirport)}}</div><div class="col-md-12 d-flex justify-content-end">{{flightIte?.flightDetailsList[flightIte?.flightDetailsList.length-1]?.toTerminal?("Terminal&nbsp;"+flightIte?.flightDetailsList[flightIte?.flightDetailsList.length-1]?.toTerminal):''}}</div></div>
      </div>
        
      </div>
    <!--+++++++++++++++++++++++++++++++++++ 2flights  ++++++++++++++++++++++++++-->
    <!--+++++++++++++++++++++++++++++++++++ 2flights  ++++++++++++++++++++++++++-->
    <!--+++++++++++++++++++++++++++++++++++ 2flights  ++++++++++++++++++++++++++-->
      <div *ngIf="false" class="panel mt-3"  (click)="togglePanel('itinerary')">
        <div class=" flex flex-middle flex-between   row" style="background-color: #1876D1; border-radius: 4px;min-height:50px;color:white;"> 
          <div class="col-md-4 "><div class="col-md-12 bold d-flex justify-content-start">{{returnFlights?.flightDetailsList[0]?.fromAirport}}</div><div class="col-md-12 justify-content-start">{{cityFilter(returnFlights.flightDetailsList[0]?.fromAirport)}}</div></div>
          <div class="col-md-4  d-flex justify-content-center "> <mat-icon class="mt-2">flight_takeoff</mat-icon></div>
    
        <div class="col-md-4   "><div class="col-md-12 bold d-flex justify-content-end">{{returnFlights?.flightDetailsList[returnFlights?.flightDetailsList.length-1]?.toAirport}}</div><div class="col-md-12 d-flex justify-content-end">{{cityFilter(returnFlights.flightDetailsList[returnFlights.flightDetailsList.length-1]?.toAirport)}}</div></div>
      </div>
       
    
        <div  class="panel-content">
          <div class="flights " >
    
            <div class="col-md-12 row"> 
              <div class="col-md-4 ">
                <div class="col-md-12 bold d-flex justify-content-start">
                  <img class="carrier-logo"  [src]="flightlogoFilter(returnFlights?.flightDetailsList[0]?.carrierName)"  alt="">
    
                </div>
               </div>
        
            <div class="col-md-6 "> <div class="col-md-12 justify-content-start">
              <div class="col-md-12 justify-content-start">{{fligthNameFilter(returnFlights?.flightDetailsList[0]?.carrierName)}}</div>
    
              <div class="col-md-12 flight-number "> {{returnFlights?.flightDetailsList[0]?.carrierName }} - {{ returnFlights?.flightDetailsList[0]?.flightNumber }}</div>
    
            </div></div>
            <mat-divider></mat-divider>
            <div class="col-md-12 flights " style="margin-top:0;padding-top: 0;">
              <div class="flight-number bold" style="color: #1876D1;"> Fare Type: </div>
               <div class="flight-number" style="color: #1876D1;">
                <!-- {{returnFlights.fare[0]?.corporateFare?('Corporate'):returnFlights.fare[0].fareType}} -->
                {{returnFlights.fare[0]?.fareTypeDisplay}}
              </div>
             </div>
          </div>
          
          
            
          </div>
    
          
        </div>
        <div class="col-md-12 row"> 
          <div class="col-md-4 "><div class="col-md-12  d-flex justify-content-start" style="font-size: 10px;">{{dateFormate(returnFlights.flightDetailsList[0]?.schDepartureTime)}}</div><div class="col-md-12 bold d-flex justify-content-start">{{returnFlights.flightDetailsList[0]?.fromAirport}}</div><div class="col-md-12 justify-content-start">{{ timeFormate(returnFlights.flightDetailsList[0]?.schDepartureTime) }}</div><div class="col-md-12  d-flex justify-content-start">{{cityFilter(returnFlights.flightDetailsList[0]?.fromAirport)}}</div><div class="col-md-12 d-flex justify-content-start">{{returnFlights.flightDetailsList[0]?.fromTerminal?("Terminal&nbsp;"+returnFlights.flightDetailsList[0]?.fromTerminal):''}}</div></div>
          <div class="col-md-4   flight-number">⌚ {{calculateDuration(returnFlights?.flightDetailsList[returnFlights?.flightDetailsList.length-1]?.schArrivalTime,returnFlights?.flightDetailsList[0]?.schDepartureTime)}}

          </div>
    
        <div class="col-md-4   "><div class="col-md-12  d-flex justify-content-end" style="font-size: 10px;">{{dateFormate(returnFlights.flightDetailsList[returnFlights.flightDetailsList.length-1]?.schArrivalTime)}}</div><div class="col-md-12 bold d-flex justify-content-end">{{returnFlights.flightDetailsList[returnFlights.flightDetailsList.length-1]?.toAirport}}</div><div class="col-md-12 d-flex justify-content-end">{{ timeFormate(returnFlights.flightDetailsList[returnFlights.flightDetailsList.length-1]?.schArrivalTime)}}</div><div class="col-md-12  d-flex justify-content-end">{{cityFilter(returnFlights.flightDetailsList[returnFlights.flightDetailsList.lenght-1]?.toAirport)}}</div><div class="col-md-12 d-flex justify-content-end">{{returnFlights.flightDetailsList[returnFlights.flightDetailsList.length-1]?.toTerminal?("Terminal&nbsp;"+returnFlights.flightDetailsList[returnFlights.flightDetailsList.length-1]?.toTerminal):''}}</div></div>
      </div>
        
      </div>
    
   <!--+++++++++++++++++++++++++++++++++++ 3flights  ++++++++++++++++++++++++++-->
    <!--+++++++++++++++++++++++++++++++++++ 3flights  ++++++++++++++++++++++++++-->
    <!--+++++++++++++++++++++++++++++++++++ 3flights  ++++++++++++++++++++++++++-->
    <div *ngIf="false" class="panel mt-3"  (click)="togglePanel('itinerary')">
      <div class=" flex flex-middle flex-between   row" style="background-color: #1876D1; border-radius: 4px;min-height:50px;color:white"> 
        <div class="col-md-4 "><div class="col-md-12 bold d-flex justify-content-start">{{thirdFlights?.flightDetailsList[0]?.fromAirport}}</div><div class="col-md-12 justify-content-start">{{cityFilter(thirdFlights?.flightDetailsList[0]?.fromAirport)}}</div></div>
        <div class="col-md-4  d-flex justify-content-center "> <mat-icon class="mt-2">flight_takeoff</mat-icon></div>
  
      <div class="col-md-4   "><div class="col-md-12 bold d-flex justify-content-end">{{thirdFlights?.flightDetailsList[thirdFlights?.flightDetailsList.length-1]?.toAirport}}</div><div class="col-md-12 d-flex justify-content-end">{{cityFilter(thirdFlights?.flightDetailsList[thirdFlights?.flightDetailsList.length-1]?.toAirport)}}</div></div>
    </div>
     
  
      <div  class="panel-content">
        <div class="flights " >
  
          <div class="col-md-12 row"> 
            <div class="col-md-4 ">
              <div class="col-md-12 bold d-flex justify-content-start">
                <img class="carrier-logo"  [src]="flightlogoFilter(thirdFlights?.flightDetailsList[0]?.carrierName)"  alt="">
  
              
              </div>
             </div>
      
          <div class="col-md-6 "> <div class="col-md-12 justify-content-start">
            <div class="col-md-12 justify-content-start">{{fligthNameFilter(thirdFlights?.flightDetailsList[0]?.carrierName)}}</div>
  
            <div class="col-md-12 flight-number "> {{thirdFlights?.flightDetailsList[0]?.carrierName }} - {{ thirdFlights?.flightDetailsList[0]?.flightNumber }}</div>
  
          </div>
          
        </div>
        <mat-divider></mat-divider>
        <div class="col-md-12 flights " style="margin-top:0;padding-top: 0;">
          <div class="flight-number bold" style="color: #1876D1;"> Fare Type: </div>
           <div class="flight-number" style="color: #1876D1;">
            <!-- {{thirdFlights.fare[0]?.corporateFare?('Corporate'):thirdFlights.fare[0].fareType}} -->
            {{thirdFlights.fare[0]?.fareTypeDisplay}}
  
          </div>
         </div>
        </div>
        
          
        </div>
  
        
      </div>
      <div class="col-md-12 row"> 
        
        <div class="col-md-4 "><div class="col-md-12  d-flex justify-content-start" style="font-size: 10px;">{{dateFormate(thirdFlights?.flightDetailsList[0]?.schDepartureTime)}}</div><div class="col-md-12 bold d-flex justify-content-start">{{thirdFlights?.flightDetailsList[0]?.fromAirport}}</div><div class="col-md-12 justify-content-start">{{ timeFormate(thirdFlights?.flightDetailsList[0]?.schDepartureTime) }}</div><div class="col-md-12  d-flex justify-content-start">{{cityFilter(thirdFlights?.flightDetailsList[0]?.fromAirport)}}</div><div class="col-md-12 d-flex justify-content-start">{{thirdFlights?.flightDetailsList[0]?.fromTerminal?("Terminal&nbsp;"+thirdFlights?.flightDetailsList[0]?.fromTerminal):''}}</div></div>
        <div class="col-md-4  flight-number ">⌚ {{calculateDuration(thirdFlights?.flightDetailsList[thirdFlights?.flightDetailsList.length-1]?.schArrivalTime,thirdFlights?.flightDetailsList[0]?.schDepartureTime)}}</div>
  
      <div class="col-md-4   "><div class="col-md-12  d-flex justify-content-end" style="font-size: 10px;">{{dateFormate(thirdFlights?.flightDetailsList[thirdFlights?.flightDetailsList.length-1]?.schArrivalTime)}}</div><div class="col-md-12 bold d-flex justify-content-end">{{thirdFlights?.flightDetailsList[thirdFlights?.flightDetailsList.length-1]?.toAirport}}</div><div class="col-md-12 d-flex justify-content-end">{{ timeFormate(thirdFlights?.flightDetailsList[thirdFlights?.flightDetailsList.length-1]?.schArrivalTime)}}</div><div class="col-md-12  d-flex justify-content-end">{{cityFilter(thirdFlights?.flightDetailsList[thirdFlights?.flightDetailsList.length-1]?.toAirport)}}</div><div class="col-md-12 d-flex justify-content-end">{{thirdFlights?.flightDetailsList[thirdFlights?.flightDetailsList.length-1]?.toTerminal?("Terminal&nbsp;"+thirdFlights?.flightDetailsList[thirdFlights?.flightDetailsList.length-1]?.toTerminal):''}}</div></div>
    </div>
      
    </div>
  
  <!--+++++++++++++++++++++++++++++++++++ 4flights  ++++++++++++++++++++++++++-->
    <!--+++++++++++++++++++++++++++++++++++ 4flights  ++++++++++++++++++++++++++-->
    <!--+++++++++++++++++++++++++++++++++++ 4flights  ++++++++++++++++++++++++++-->
    <div *ngIf="false" class="panel mt-3"  (click)="togglePanel('itinerary')">
      <div class=" flex flex-middle flex-between   row" style="background-color: #1876D1; border-radius: 4px;min-height:50px;color:white"> 
        <div class="col-md-4 "><div class="col-md-12 bold d-flex justify-content-start">{{fourthFlights?.flightDetailsList[0]?.fromAirport}}</div><div class="col-md-12 justify-content-start">{{cityFilter(fourthFlights?.flightDetailsList[0]?.fromAirport)}}</div></div>
        <div class="col-md-4  d-flex justify-content-center "> <mat-icon class="mt-2">flight_takeoff</mat-icon></div>
  
      <div class="col-md-4   "><div class="col-md-12 bold d-flex justify-content-end">{{fourthFlights?.flightDetailsList[fourthFlights?.flightDetailsList.length-1]?.toAirport}}</div><div class="col-md-12 d-flex justify-content-end">{{cityFilter(fourthFlights?.flightDetailsList[fourthFlights?.flightDetailsList.length-1]?.toAirport)}}</div></div>
    </div>
     
  
      <div  class="panel-content">
        <div class="flights " >
  
          <div class="col-md-12 row"> 
            <div class="col-md-4 ">
              <div class="col-md-12 bold d-flex justify-content-start">
                <img class="carrier-logo"  [src]="flightlogoFilter(fourthFlights?.flightDetailsList[0]?.carrierName)"  alt="">
  
              
              </div>
             </div>
      
          <div class="col-md-6 "> <div class="col-md-12 justify-content-start">
            <div class="col-md-12 justify-content-start">{{fligthNameFilter(fourthFlights?.flightDetailsList[0]?.carrierName)}}</div>
  
            <div class="col-md-12 flight-number "> {{fourthFlights?.flightDetailsList[0]?.carrierName }} - {{ fourthFlights?.flightDetailsList[0]?.flightNumber }}</div>
  
          </div>
          
        </div>
        <mat-divider></mat-divider>
        <div class="col-md-12 flights " style="margin-top:0;padding-top: 0;">
          <div class="flight-number bold" style="color: #1876D1;"> Fare Type: </div>
           <div class="flight-number" style="color: #1876D1;">
            <!-- {{fourthFlights.fare[0]?.corporateFare?('Corporate'):fourthFlights.fare[0].fareType}} -->
            {{fourthFlights.fare[0]?.fareTypeDisplay}}
          </div>
         </div>
        </div>
        
          
        </div>
  
        
      </div>
      <div class="col-md-12 row"> 
        
        <div class="col-md-4 "><div class="col-md-12  d-flex justify-content-start" style="font-size: 10px;">{{dateFormate(fourthFlights?.flightDetailsList[0]?.schDepartureTime)}}</div><div class="col-md-12 bold d-flex justify-content-start">{{fourthFlights?.flightDetailsList[0]?.fromAirport}}</div><div class="col-md-12 justify-content-start">{{ timeFormate(fourthFlights?.flightDetailsList[0]?.schDepartureTime) }}</div><div class="col-md-12  d-flex justify-content-start">{{cityFilter(fourthFlights?.flightDetailsList[0]?.fromAirport)}}</div><div class="col-md-12 d-flex justify-content-start">{{fourthFlights?.flightDetailsList[0]?.fromTerminal?("Terminal&nbsp;"+fourthFlights?.flightDetailsList[0]?.fromTerminal):''}}</div></div>
        <div class="col-md-4  flight-number ">⌚ {{calculateDuration(fourthFlights?.flightDetailsList[fourthFlights?.flightDetailsList.length-1]?.schArrivalTime,fourthFlights?.flightDetailsList[0]?.schDepartureTime)}}</div>
  
      <div class="col-md-4   "><div class="col-md-12  d-flex justify-content-end" style="font-size: 10px;">{{dateFormate(fourthFlights?.flightDetailsList[fourthFlights?.flightDetailsList.length-1]?.schArrivalTime)}}</div><div class="col-md-12 bold d-flex justify-content-end">{{fourthFlights?.flightDetailsList[fourthFlights?.flightDetailsList.length-1]?.toAirport}}</div><div class="col-md-12 d-flex justify-content-end">{{ timeFormate(fourthFlights?.flightDetailsList[fourthFlights?.flightDetailsList.length-1]?.schArrivalTime)}}</div><div class="col-md-12  d-flex justify-content-end">{{cityFilter(fourthFlights?.flightDetailsList[fourthFlights?.flightDetailsList.length-1]?.toAirport)}}</div><div class="col-md-12 d-flex justify-content-end">{{fourthFlights?.flightDetailsList[fourthFlights?.flightDetailsList.length-1]?.toTerminal?("Terminal&nbsp;"+fourthFlights?.flightDetailsList[fourthFlights?.flightDetailsList.length-1]?.toTerminal):''}}</div></div>
    </div>
      
    </div>
  
  
      
    </div>
    
               
              </div>
            </div>
    
            </div>
          </div>
        </div>
      </div>
           
              
    
      <div class="modal" id="myMod" [style.display]="seatPopup ? 'block' : 'none'" >
        <div class="modal-dialog" >
            <div class="modal-content " >
                <div class="modal-header title">
                  
                  <h4 >Flight Seat Selection</h4>
                  <button  type="button" class="close" data-dismiss="modal" (click)="closePopup()">&times;</button>
    
                  </div>
                  <div class="modal-body"  style="overflow: auto; max-height: 60vh;" >
                    
                    <div class="row col-md-12">
                      <div class="col-md-4 ">
                    <div  class="col-md-12  flightDetails mt-4 " style="overflow-y: auto;height: 60vh; font-size: small; width: 100%;padding: 5px; ">
                      <div style="padding-top: 20px;"></div>
                      <div class="" style="font-size: 16px;text-align: center;font-weight: 700;">{{cityFilter(flightSeatMapping?.fromAirport)+'-'+cityFilter(flightSeatMapping?.toAirport)}}</div>
                      <!-- <mat-paginator  class="col-md-12  mb-1 " style="background-color: transparent;" color="primary"
                      [pageSize]="1"
                      [pageSizeOptions]="[1, 2, 3, 4]"
                      [length]="totalElements"
                      (page)="nextPage($event)"
                      aria-label="Select page"
                      hidePageSize="true">
                      </mat-paginator> -->
    
                      <div class="title" style="font-size: 16px;text-align: center;font-weight: 700;">Passenger</div>
                      <div class="col-md-12 row">
    
                       <div class="col-md-6 row mt-1 mb-1"   *ngFor="let con of flightMealDetails; let i=index" >
                         <div class="col-md-6 pt-1 bold">
                          <!-- con.passengerType==="INF"?("Infant") -->
                          {{con.passengerType==="ADT"?("Adult"):con.passengerType==="CHD"?("Child"):''}}&nbsp;{{i+1}}
                        </div>
                        <div class="col-md-6">
       
                        <li  class="seat" style="width: 30px;height: 25px;" >
                          <input type="checkbox"/>
                         <label *ngIf="flightType==='oneWay'"  style=" background: #bada55; " >{{con.flight.flightDetailsList[flightIndex].seat||'&nbsp;'}}</label>
                         <label *ngIf="flightType==='return'"  style=" background: #bada55; " >{{con.returnFlights.flightDetailsList[flightIndex].seat||'&nbsp;'}}</label>
                         <label *ngIf="flightType==='thirdFlight'"  style=" background: #bada55; " >{{con.thirdFlights.flightDetailsList[flightIndex].seat||'&nbsp;'}}</label>
                         <label *ngIf="flightType==='fourthFlight'"  style=" background: #bada55; " >{{con.fourthFlights.flightDetailsList[flightIndex].seat||'&nbsp;'}}</label>
    
                       </li>
                     </div>
                    </div>
                    <!-- <div class="col-md-6 row mt-1 mb-1"   *ngFor="let con of passengerChild.controls; let i=index" >
                     <div class="col-md-6 pt-1 bold">Child&nbsp;{{i+1}}</div>
                    <div class="col-md-6">
    
                    <li  class="seat" ><input type="checkbox"     />
                     <label  style=" background: #bada55;">&nbsp;</label>
                   </li>
                 </div>
                </div> -->
                <!-- <div class="col-md-6 row mt-1 mb-1"   *ngFor="let con of passengerInfent.controls; let i=index" >
                 <div class="col-md-6 pt-1 bold">Infant&nbsp;{{i+1}}</div>
                <div class="col-md-6">
    
                <li  class="seat" ><input type="checkbox"     />
                 <label  style=" background: #bada55;">&nbsp;</label>
               </li>
             </div>
            </div> -->
           </div>
    
                    <div  class="title" style="font-size: 16px;text-align: center;font-weight: 700;">Legends</div>
    
                      <div class="col-md-12 row mt-1 mb-1" > 
                       <div class="col-md-6 pt-1 bold">Available</div> 
                       <div class="col-md-6">
                       <li  class="seat" style="width: 30px;height: 25px;" ><input type="checkbox"     />
                        <label style=" background: #44a2f7;" >&nbsp;&nbsp;</label>
                      </li>
                    </div>
                   </div>
                   <mat-divider></mat-divider>
    
                      <div class="col-md-12 row mt-1 mb-1">
                        <div class="col-md-6 pt-1 bold">Occupied</div>
                       <div class="col-md-6">
    
                       <li  style="width: 30px;height: 25px;" class="seat" >
                         <input type="checkbox" disabled    />
                        <label  >&nbsp;</label>
                      </li>
                    </div>
                   </div>
                   <mat-divider></mat-divider>
                   <div  class="col-md-12 row mt-1 mb-1">
                     <div class="col-md-6 pt-1 bold">Selected</div>
                    <div class="col-md-6">
    
                    <li  class="seat" style="width: 30px;height: 25px;" ><input type="checkbox"     />
                     <label  style=" background: #bada55;">&nbsp;</label>
                   </li>
                 </div>
                </div>
                <mat-divider></mat-divider>
                <div  class="col-md-12 row mt-1 mb-1">
                  <div class="col-md-6 pt-1 bold">RESTRICTED</div>
                 <div class="col-md-6">
  
                 <li  class="seat" style="width: 30px;height: 25px;" >
                  <input type="checkbox"  disabled   />
                  <label  style=" background: #7d7d7d;">&nbsp;</label>
                </li>
              </div>
             </div>
             <mat-divider></mat-divider>
             <div  class="col-md-12 row mt-1 mb-1">
              <div class="col-md-6 pt-1 bold">CHARGEABLE</div>
             <div class="col-md-6">
  
             <li  class="seat" style="width: 30px;height: 25px;" >
              <input type="checkbox"     />
              <label  style=" background: #d42525;">&nbsp;</label>
            </li>
          </div>
         </div>
         <mat-divider></mat-divider>
    
                       
                       <!-- <div class="col-md-12"><span>Exit Row</span>  </div>
                         <div class="col-md-12" ><span>Paid Offline Seat</span></div> -->
    
                         </div>
                        </div>
    
                     <div *ngIf="seats.length!=0" class="col-md-8" style="overflow-y: auto;height: 60vh; "> 
                      
     <!-- <div class="seat-map " >
     
            <span class="flight">
       <div class="row" *ngFor="let row of rows"  style="padding-left: 100px;" >
         <div class="seat " *ngFor="let seat of seats"  (click)="toggleSeat(row, seat)" [ngClass]="{ 'aisle': isAisle(row, seat) }"  [class.selected]="isSeatSelected(row, seat)">
           <div
             class="seat-item" 
             >
             {{ row }}{{ seat }} 
     
           </div>
           
         </div>
       </div>
     </span>
     </div> -->
     <div  class="plane">
       <div class="cockpit">
         <img src="../../../assets/images/cockpit-top.png" alt="">
         <h3>FRONT</h3>
       </div>
       <div class="exit exit--front fuselage"></div>
       <ol class="cabin fuselage">
         <li *ngFor="let seat of seats" class="row" [class.row--{{row}}]="true">
           <ol class="seats" type="A">
             <li *ngFor="let row of rows" class="seat" [ngbPopover]="popoverContent" container="body"
             triggers="mouseenter:mouseleave" >
               <input  type="checkbox"  [ngClass]="{
                'chargeable': isChargeable(row, seat),
                'restricted': isRestricted(row, seat)
              }" [required]="isrequired(row, seat)" [disabled]="isAisle(row, seat)" id="{{row}}{{seat}}" (click)="toggleSeat(row, seat)"   [class.selected]="isSeatSelected(row, seat)" />
               <label for="{{row}}{{seat}}"  >{{row}}{{seat}}</label>
               <!-- [style]="isRestricted(row, seat)?('background: #7d7d7d;'):isChargeable(row, seat)?('background: #d42525;'):''" -->
               <ng-template #popoverContent class="col-md-12"  >
                <small style="font-size: 10px;">{{popoverSeatPrice(row,seat)}} </small>
                  <!-- and 3405 reviews -->
                
                
                </ng-template>
             </li>
           </ol>
         </li>
       </ol>
      
       <div class="exit exit--back fuselage"></div>
     </div>
     
     </div> 
    </div>
    
    
    
    
        
                </div>
    
                  <div class="modal-footer" >
                    <div class="form-group form-inline ">
                      <label for="userName" class="col-md-5 col-form-label control-label"> </label>
                    </div>   
                      <button type="button" class="btn btn-outline-primary c-width-100px shadow" data-dismiss="modal" (click)="closePopup()">Close</button>
                 
                  </div>
    
                 
    
          </div>
      </div>
    </div>
    <p-sidebar [(visible)]="showSidebar" position="left" styleClass="col-md-8" >
      <ng-template pTemplate="header">
        <strong class="col-md-11 font-semibold text-xl">Advanced Pricing</strong>
          
        <!-- pTemplate="headless" -->
      
    </ng-template>
    <span *ngFor="let flightsItem of flightArray;let flightsItemIndex = index" >
      
      <strong ><img class="carrier-logo" [src]="flightlogoFilter(flightsItem?.flightDetailsList[0]?.carrierName)"  alt="">
        {{fligthNameFilter(flightsItem?.flightDetailsList[0]?.carrierName)+"-"+flightsItem?.flightDetailsList[0]?.flightNumber}} {{cityFilter(flightsItem?.flightDetailsList[0]?.fromAirport)+"-"+cityFilter(flightsItem?.flightDetailsList[flightsItem?.flightDetailsList.length - 1]?.toAirport)}}</strong>
    <table   class="styled-tables col-md-12" >
      <thead>
        <tr >
          <th style="padding: 8px;  text-align: center;">Base   </th>
          <th style="padding: 8px;  text-align: center;">Tax  </th>
          <th style="padding: 8px;  text-align: center;">Fee  </th>
  
  
  
        </tr>
      </thead>
      
       
      <tbody  *ngFor="let traveller of travellerArray(travellerDetail.adult,flightsItem?.advancedPricingData?.advancedPricingList,'ADT');let i=index" >
        <tr >
          <td class="value-cell"><strong>Adult {{i+1}}</strong> {{flightsItem?.flightDetailsList[0]?.fromAirport+"-"+flightsItem?.flightDetailsList[flightsItem?.flightDetailsList.length - 1]?.toAirport}}:{{flightsItem?.flightDetailsList[0]?.carrierName+"-"+flightsItem?.flightDetailsList[0]?.flightNumber}}</td>
          <td class="value-cell"></td>
          <td class="value-cell"></td>
          </tr>
        <tr >
         
          <td  style="padding: 8px;"><input (input)="SubmitAdvancePricing($event, flightsItemIndex, 'ADT', 'baseAmt', i)" readonly [ngModel]="traveller?.baseAmt"  type="text" (keypress)="onlyNumberKey($event)"></td>
          <td  style="padding: 8px;"><input (input)="SubmitAdvancePricing($event, flightsItemIndex, 'ADT', 'taxAmt', i)"  [ngModel]="traveller?.taxAmt" type="text" (keypress)="onlyNumberKey($event)"></td>
          <td  style="padding: 8px;"><input (input)="SubmitAdvancePricing($event, flightsItemIndex, 'ADT', 'feeAmt', i)" readonly  [ngModel]="traveller?.feeAmt" type="text" (keypress)="onlyNumberKey($event)"></td>
        
        
  
        </tr>
      </tbody>
  
        <tbody *ngFor="let traveller of travellerArray(travellerDetail.child,flightsItem?.advancedPricingData?.advancedPricingList,'CHD');let i=index" >
  
        <tr >
          <td class="value-cell"><strong>Child {{i+1}}</strong> {{flightsItem?.flightDetailsList[0]?.fromAirport+"-"+flightsItem?.flightDetailsList[flightsItem?.flightDetailsList.length - 1]?.toAirport}}:{{flightsItem?.flightDetailsList[0]?.carrierName+"-"+flightsItem?.flightDetailsList[0]?.flightNumber}}</td>
          <td class="value-cell"></td>
          <td class="value-cell"></td>
          </tr>
        <tr >
         
          <td  style="padding: 8px;"><input (input)="SubmitAdvancePricing($event, flightsItemIndex, 'CHD', 'baseAmt', i+travellerDetail.adult)" readonly [ngModel]="traveller?.baseAmt"  type="text" (keypress)="onlyNumberKey($event)"></td>
          <td  style="padding: 8px;"><input (input)="SubmitAdvancePricing($event, flightsItemIndex, 'CHD', 'taxAmt', i+travellerDetail.adult)" [ngModel]="traveller?.taxAmt" type="text" (keypress)="onlyNumberKey($event)"></td>
          <td  style="padding: 8px;"><input (input)="SubmitAdvancePricing($event, flightsItemIndex, 'CHD', 'feeAmt', i+travellerDetail.adult)" readonly [ngModel]="traveller?.feeAmt" type="text" (keypress)="onlyNumberKey($event)"></td>
        
  
        </tr>
      </tbody>
  <tbody *ngFor="let traveller of travellerArray(travellerDetail.infantCount,flightsItem?.advancedPricingData?.advancedPricingList,'INF'); let i=index">
    <tr >
      <td class="value-cell"><strong>Infant {{i+1}}</strong> {{flightsItem?.flightDetailsList[0]?.fromAirport+"-"+flightsItem?.flightDetailsList[flights?.flightDetailsList.length - 1]?.toAirport}}:{{flightsItem?.flightDetailsList[0]?.carrierName+"-"+flightsItem?.flightDetailsList[0]?.flightNumber}}</td>
      <td class="value-cell"></td>
      <td class="value-cell"></td>
      </tr>
        <tr >
         
          <td  style="padding: 8px;"><input (input)="SubmitAdvancePricing($event, flightsItemIndex, 'INF', 'baseAmt', i+travellerDetail.adult+travellerDetail.child)" readonly [ngModel]="traveller?.baseAmt" type="text" (keypress)="onlyNumberKey($event)"></td>
          <td  style="padding: 8px;"><input (input)="SubmitAdvancePricing($event, flightsItemIndex, 'INF', 'taxAmt', i+travellerDetail.adult+travellerDetail.child)"   [ngModel]="traveller?.taxAmt" type="text" (keypress)="onlyNumberKey($event)"></td>
          <td  style="padding: 8px;"><input (input)="SubmitAdvancePricing($event, flightsItemIndex, 'INF', 'feeAmt', i+travellerDetail.adult+travellerDetail.child)"  readonly [ngModel]="traveller?.feeAmt" type="text" (keypress)="onlyNumberKey($event)"></td>
        
  
        </tr>
        
        
      </tbody>
    
    </table>
    <br>
    </span>
    <ng-template pTemplate="footer">
      <div class=" d-flex justify-content-end">
    <span class="bold " style="margin-right:10px ;font-size: 23px;">Total Price : {{advanceTotal}} INR </span>
  <button mat-flat-button style="color: white;background-color: #1876D0;" (click)="submit()">Close</button>
    </div>
   </ng-template>
  </p-sidebar>
    
            
              
    
    
        
    